﻿(function () {
    'use strict';
    var controllerId = 'appointmentCreateCtrl2';
    angular
        .module('app.controllers')
        .controller(controllerId, appointmentCreateCtrl2)

    appointmentCreateCtrl2.$inject = ['common', 'datacontext', '$http', '$scope', '$rootScope', '$state', '$stateParams', '$translate', '$window', '$timeout', 'configConstants'];

    function appointmentCreateCtrl2(common, datacontext, $http, $scope, $rootScope, $state, $stateParams, $translate, $window, $timeout, configConstants) {
        let config = common.config;
        let vm = this;

        vm.spinnerOptions = {
            radius: 20,
            lines: 11,
            length: 1,
            width: 8,
            speed: 1.7,
            corners: 1.0,
            trail: 100,
            color: '#146794'
        };

        vm.ClickButtonSave = false;
        vm.IsChangeDepot = false;
        vm.customerId = "";
        vm.fecha = "";
        vm.hora = "";
        vm.fechahora = "";
        vm.placa = "";
        vm.date;
        vm.CleanText = false;
        vm.fromSelected = false;
        vm.varaditional = "";
        vm.dataTruckerId = "";
        vm.dataDriverId = "";
        vm.changeSelected = changeSelected;
        vm.focusOutAuto = focusOutAuto;
        vm.clearPlateTxt = clearPlateTxt;
        vm.selectedDriverFnDefinition = selectedDriverFnDefinition;
        vm.yardsList = {};
        vm.actiontypeList = {};
        vm.documenttypeList = {};
        vm.equipmentsizeAllow1 = {};
        vm.equipmentsizeAllow2 = {};
        vm.driverdocuments = {};
        vm.driverdocumentsgrid = [];
        vm.truckdocumentsgrid = [];
        vm.depotorderinfo = [];
        vm.truckerDriverAllowed = [];
        vm.truckerPlateAllowed = [];
        vm.selectedDriver = {};
        vm.selectedTrucker = {};
        vm.selectedTruckerObj = {};
        vm.selectedDepotOrder = {};
        vm.selectedDeporOrderObj = {};
        vm.selectedReferenceNo = {};
        vm.selectedRut = {};
        vm.selectedRutObj = {};
        vm.selectedAssignedTo = {};
        vm.selectedAssignedToObj = {};
        vm.selectedTruckerRut = {};
        vm.selectedTruckerRutObj = {};
        vm.selectedTruckerName = "";
        vm.selectedTruckerPlate = {};
        vm.selectedTruckerPlateObj = {};
        vm.varyard = "";
        vm.varyardname = "";
        vm.customerServices = [];
        vm.customerServiceCurrent = {};
        vm.varactiontype = "";
        vm.varactiontypename = "";
        vm.referenceno = "";
        vm.headerNameGateStatus = "";
        vm.roleSelected = "";
        vm.isOnlyPortalUser = false;
        vm.truckerDriverRequired = false;
        vm.truckerPlateRequired = false;
        vm.operationtypemovement = "";
        vm.appointmentId;
        vm.appoinments = [];
        vm.appointmentTemplateId;
        vm.alpha;
        vm.type;
        vm.typeHours;
        vm.typeDate;
        vm.showAll = false;
        vm.cargainicial = true;
        vm.isEdit = false;
        vm.isEditDisabled = false;
        vm.muestraCheck = true;
        vm.botonAccion = $translate.instant('views.appointment.save');
        vm.tituloPrincipal = $translate.instant('views.appointment.titleAppointmentCreate');
        vm.saveAppointment = saveAppointment;
        vm.getEquipments = getEquipments;
        vm.limpiaBusquedaEquipos = limpiaBusquedaEquipos;
        vm.multipleCreation2 = multipleCreation2;
        vm.inputChangedTruckerPlate = inputChangedTruckerPlate;
        vm.bpnombre = "";
        vm.bpPlateNo = "";
        vm.bpcorreo = "";
        vm.bptelefono = "";
        vm.getDocumentTypes = getDocumentTypes;
        vm.getDriverDocuments = getDriverDocuments;
        vm.closeNewDriverDlg = closeNewDriverDlg;
        vm.saveDocuments = saveDocuments;
        vm.saveTruckDocumentTypes = saveTruckDocumentTypes;
        vm.getDepotOrderInfo = getDepotOrderInfo;
        vm.searchDepotOrder = searchDepotOrder;
        vm.showAddDriverModal = showAddDriverModal;
        vm.showAddPlateNoModal = showAddPlateNoModal,
        vm.goAppointments = goAppointments;
        vm.goMain = goMain;
        vm.moveRow = moveRow;
        vm.deleteRow = deleteRow;
        vm.validacionesIniciales = 0;
        vm.clearDepotOrder = clearDepotOrder;
        vm.validateBusinessPartner = validateBusinessPartner;
        vm.validatePlate = validatePlate;
        vm.createNewDatasource = createNewDatasource;
        vm.createNewDatasourceDocumentos = createNewDatasourceDocumentos;
        vm.createNewDatasourcePlateNoDocuments = createNewDatasourcePlateNoDocuments;
        vm.appointmentNo = "";
        vm.equipment = "";

        //multiple
        vm.apptsInfo = null;
        vm.fechasSeleccionadas = "";
        vm.hideMultiple = true;
        vm.isMultiple = false;
        vm.gridMultipleVisible = false;
        vm.MultipleDatesTotal = [];
        vm.yardScheduleHourDetailPersonalizes = [];
        //

        //Constants
        vm.TruckerBPRoleCode = "TRU";
        vm.ShipperBPRoleCode = "SHI";

        var datappointments;
        var datappointment;

        vm.varactiontype = $window.sessionStorage ? $window.sessionStorage.codeActionType : "";
        vm.headerNameGateStatus = vm.varactiontype == "D" ? $translate.instant('views.appointment.inGate') : $translate.instant('views.appointment.inGateCompleted');

        var permissionPage = configConstants.enums.pages.gateOut;
        switch (vm.varactiontype) {
            case "D": {
                permissionPage = configConstants.enums.pages.gateIn;
            } break;
            case "P": {
                permissionPage = configConstants.enums.pages.gateOut;
            } break;
        }
        vm.permissionHide = common.getPermissionByPage(permissionPage);

        var columnDefs = [
            { headerName: "Id", field: "AppointmentId", hide: true, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true, },
            { headerName: "IdEquipment", field: "EquipmentId", hide: true, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: "isActive", field: "IsActive", hide: true, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true, filter: 'number' },
            { headerName: "Sel", hide: true, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true, checkboxSelection: true, filter: 'number' },
            { 
                headerName: $translate.instant('views.appointment.container'), field: "EquipmentNo", height: 150, width: 140, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true, cellRenderer: function (params) {
                    if(params.value){
                        let yard = vm.yardsList.find(x=>x.YardId == params.data.YardId);
                        let msgYard = $translate.instant('views.appointment.equipmentYard') + (yard != null ? yard.Name : '');
                        return '<div title="' + msgYard + '">' + params.value + '</div>';
                    }else{
                        return '';
                    }
                }
            },
            { headerName: "Iso Code", hide: true, field: "ISOCode", height: 50, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: "Size Value", hide: true, field: "SizeValue", height: 50, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: $translate.instant('views.appointment.sizeType'), width: 150, field: "SizeTypeName", height: 50, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: $translate.instant('views.appointment.carrier'), field: "CarrierName", height: 50, width: 220, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: 'Doc. Ref', field: "ReferenceDocumentNo", height: 50, width: 130, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: $translate.instant('views.appointment.depotOrder'), field: "DepotOrderNo", height: 150, width: 140, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            {
                headerName: vm.headerNameGateStatus, field: "InGate", height: 50, width: 140, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true, cellRenderer: function (params) {
                    if (params.value)
                        return '<img class="srch" src="assets/img/icons/ic_check.png" style="width:20px;height:20px">';
                    else
                        return '';
                }
            },
            {
                headerName: $translate.instant('views.appointment.statusName'), hide: true, field: "StatusName", height: 50, width: 140, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true, cellRenderer: function (params) {
                    if (params.value) {
                        if (params.data.StatusColor && params.data.StatusName)
                            return "<label><div class='entitystatusdisplay' style='background-color:" + params.data.StatusColor + "'>" + params.data.StatusName + "</div></label>";
                        else
                            return "";
                    }
                    else
                        return '';
                }
            },

            { headerName: "CarrierId", field: "CarrierId", hide: true, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: "ClassId", field: "ClassId", hide: true, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: "Clase", field: "ClassDescription", height: 50, width: 110, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true, hide: vm.varactiontype == "D" ? true : false },
            { headerName: 'Temperatura', field: "Temperature", height: 50, width: 130, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true, hide: vm.varactiontype == "D" ? true : false },
            {
                headerName: "Agregar", height: 50, width: 104, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true,
                cellRenderer: function (params) {

                    if (!params.data.IsDisabled &&
                        ((params.data.DepotOrderEquipmentId != null && parseInt(params.data.DepotOrderEquipmentId) > 0)
                         ||
                         (params.data.DepotOrderSummaryId != null && parseInt(params.data.DepotOrderSummaryId) > 0)
                        )
                        &&
                        (params.data.AppointmentId == 0
                         ||
                         params.data.AppointmentId == vm.appointmentId
                        ) &&
                        (!params.data.YardId || params.data.YardId == common.localStorageService.get('selectedYard').yard)
                    ) {
                        let a = document.createElement('a');
                        a.innerHTML = '<a href="javascript: void (0);"><i class="fa fa-plus-square-o blue" style="font-size: 1.25em;"></i></a>';
                        a.addEventListener('click', function () {
                          moveRow(params.data.DepotOrderEquipmentId);
                        });
                        return a;
                    }
                }
            }
        ];

        //grillaFinal a donde pasa la data
        var columnDefs2 = [
            { headerName: "Horario", field: "PeriodPerAppt", hide: true, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true, cellRenderer: customMultipleDatesEditor },
            { headerName: "Id", field: "AppointmentId", hide: true, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true, },
            { headerName: "IdEquipment", field: "EquipmentId", hide: true, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: "isActive", field: "IsActive", hide: true, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true, filter: 'number' },
            { headerName: "Size Value", field: "SizeValue", hide: true, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: "Sel", hide: true, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true, checkboxSelection: true, filter: 'number', width: 72 },
            { headerName: $translate.instant('views.appointment.container'), field: "EquipmentNo", height: 150, width: 140, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: "Iso Code", hide: true, field: "ISOCode", height: 50, width: 120, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: $translate.instant('views.appointment.sizeType'), field: "SizeTypeName", height: 50, width: 150, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: 'Empresa de Transporte', hide: true, field: "MultipleTruckerName", height: 50, width: 250, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: 'Conductor', hide: true, field: "MultipleDriverName", height: 50, width: 170, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: 'Placa', hide: true, field: "MultiplePlate", height: 50, width: 110, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: $translate.instant('views.appointment.carrier'), field: "CarrierName", height: 50, width: 220, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: 'Doc Ref.', field: "ReferenceDocumentNo", height: 50, width: 130, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            {
                headerName: $translate.instant('views.appointment.depotOrder'), field: "DepotOrderNo", height: 150, width: 140, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true, cellRenderer: function (params) {
                    if (params.data) {
                        if (params.data.DepotOrderId)
                        {
                            let a = document.createElement('a');
                            a.innerHTML = '<a href="javascript: void (0);">' + params.data.DepotOrderNo +'</a>';
                            a.addEventListener('click', function () {
                                getDepotOrderInfo(params.data.DepotOrderId);
                            });
                            return a;
                        }
                        else
                            return "";
                    }
                    else
                        return '';

                }
            },                        
            {
                headerName: vm.headerNameGateStatus, field: "InGate", height: 50, width: 140, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true, cellRenderer: function (params) {
                    if (params.value)
                        return '<img class="srch" src="assets/img/icons/ic_check.png" style="width:20px;height:20px">';                    
                    else
                        return '';
                }
            },
            {
                headerName: $translate.instant('views.appointment.statusName'), field: "StatusName", hide: true, height: 50, width: 150, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true, cellRenderer: function (params) {
                    if (params.value) {
                        if (params.data.StatusColor && params.data.StatusName)
                            return "<label><div class='entitystatusdisplay' style='background-color:" + params.data.StatusColor + "'>" + params.data.StatusName + "</div></label>";
                        else
                            return "";
                    }
                    else
                        return '';
                }
            },
            { headerName: "Clase", field: "ClassDescription", height: 50, width: 110, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true, hide: vm.varactiontype == "D" ? true : false },
            { headerName: 'Temperatura', field: "Temperature", height: 50, width: 130, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true, hide: vm.varactiontype == "D" ? true : false },
            {
                headerName: "Eliminar", height: 50, width: 104, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true,
                cellRenderer: function (params) {                    
                    if (vm.isEditDisabled == false)
                        // return "<a href='javascript:;' onclick='vm.deleteRow(" + params.data.AppointmentId + ", " + params.data.AppointmentEquipmentId + ", " + params.data.DepotOrderId + ", " + params.data.DepotOrderEquipmentId + ");'><i class='fa fa-minus-square-o blue' style='font-size: 1.25em;'></i></a>";
                    {
                        let a = document.createElement('a');
                        a.innerHTML = '<a href="javascript: void (0);"><i class="fa fa-minus-square-o blue" style="font-size: 1.25em;"></i></a>';
                        a.addEventListener('click', function () {
                            deleteRow(params.data.AppointmentId, params.data.AppointmentEquipmentId, params.data.DepotOrderId, params.data.DepotOrderEquipmentId);
                        });
                        return a;
                    }
                }
            }
        ];

        var columnDefs3 = [
            { headerName: "SizeTypeId", field: "SizeTypeId", hide: true, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: "Cantidad por Cita", field: "PeriodPerAppt", suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true, cellRenderer: customEditor },
            { headerName: "Por Agendar", field: "ScheduledEquipments", suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true, editable: true, newValueHandler: numberNewValueHandler },
            { headerName: $translate.instant('views.appointment.sizeType'), field: "SizeTypeName", height: 50, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: "DepotOrder No", field: "DepotOrderNo", height: 50, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true, 
                cellRenderer: function (params) { 
                    if (params.data.DepotOrderId) {
                        let a = document.createElement('a');
                        a.innerHTML = '<a href="javascript: void (0);">' + params.data.DepotOrderNo +'</a>';
                        a.addEventListener('click', function () {
                            getDepotOrderInfo(params.data.DepotOrderId);
                        });
                        return a;
                    } 
                } 
            },
            { headerName: "Cantidad Total", field: "SizeTypeQnt", suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: "Agendados/Completados", field: "UsedEquipments", suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
        ];

        var columnDefs4 = [
            { headerName: "DepotOrderSummaryId", field: "DepotOrderSummaryId", hide: true, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: "SizeAndTypeId", field: "SizeAndTypeId", hide: true, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: $translate.instant('views.appointment.sizeType'), field: "SizeAndType", suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: "Cantidad", field: "Quantity", width: 100, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: "Pendientes", field: "Pending", width: 100, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: "Asignados", field: "Assigned", width: 100, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: "En Progreso", field: "InProgress", width: 100, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: "Completados", field: "Completed", width: 125, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
            { headerName: "Autorizados", field: "Authorization", width: 125, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
        ];

        vm.pageSize = '500';

        $scope.clearInput = function () {
            $scope.$broadcast('angucomplete-alt:clearInput', 'placa');
        }

        function clearPlateTxt() {
            $scope.$broadcast('angucomplete-alt:clearInput', 'placa');
        }

        //grilla que cambia la informacion segun la(s) depot order(s) seleccionadas
        vm.gridOptions = {
            height: 150,
            enableColResize: true,
            enableFilter: true,
            rowData: null,
            rowSelection: 'multiple',
            columnDefs: columnDefs,
            suppressRowClickSelection: true,
            cellClicked: cellClickedfunct,
            ready: function (griApiWrapper) {
                griApiWrapper.api.showLoading(false);
            }
        };

        vm.transportista = {};
        vm.transportistadocumentos = {};
        var columnDefs1 = [
            { headerName: "RoleTypeId", field: "RoleTypeId", suppressMenu: true, cellStyle: { 'text-align': 'left' }, suppressSorting: true, hide: true },
            { headerName: "DocumentTypeId", field: "DocumentTypeId", suppressMenu: true, cellStyle: { 'text-align': 'left' }, suppressSorting: true, hide: true },
            { headerName: "DocumentType", field: "DocumentType", suppressMenu: true, cellStyle: { 'text-align': 'left' }, suppressSorting: true, hide: true },
            { headerName: "Documento", field: "DocumentName", suppressMenu: true, cellStyle: { 'text-align': 'left' }, suppressSorting: true, },
            { headerName: "N° Documento", field: "DocumentNumber", width: 125, suppressMenu: true, cellStyle: { 'text-align': 'left' }, suppressSorting: true, editable: true, newValueHandler: docNumValueHandler },
            { headerName: "Fecha Inicio", field: "StartDateString", width: 125, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true, editable: true, newValueHandler: datesValueHandler },
            { headerName: "Fecha Fin", field: "ExpirationDateString", width: 125, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true, editable: true, newValueHandler: datesValueHandler }
        ];

        var columnTruckDocumentTypes = [
            { headerName: "TruckDocumentTypeTruckId", field: "TruckDocumentTypeTruckId", suppressMenu: true, cellStyle: { 'text-align': 'left' }, suppressSorting: true, hide: true },
            { headerName: "TruckDocumentTypeId", field: "TruckDocumentTypeId", suppressMenu: true, cellStyle: { 'text-align': 'left' }, suppressSorting: true, hide: true },
            { headerName: "Documento", field: "TruckDocumentTypeName", suppressMenu: true, cellStyle: { 'text-align': 'left' }, suppressSorting: true, },
            { headerName: "N° Documento", field: "DocumentNumber", width: 125, suppressMenu: true, cellStyle: { 'text-align': 'left' }, suppressSorting: true, editable: true, newValueHandler: docNumValueHandler },
            { headerName: "Fecha Inicio", field: "StartDateString", width: 125, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true, editable: true, newValueHandler: datesValueHandler },
            { headerName: "Fecha Fin", field: "ExpirationDateString", width: 125, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true, editable: true, newValueHandler: datesValueHandler }
        ];
vm.clickBuscar = function () {
    var name = $("#ReferenceDocumentNo").val();
    var equipment = $("#Equipment").val();

    var request = {
        criteria: name, equipmentNo: equipment, doctypeId: vm.vardocumenttype, actionType: vm.varactiontype,
        yardId: vm.varyard, operationTypeMovementCode: vm.operationtypemovement, shipperId: getShipperId(),
        yardScheduleHourId: $window.sessionStorage.yardScheduleHourId, appointmentDate: $window.sessionStorage.dateString
    };

    datacontext.appointment.getDepotOrderByRefDocNoOrEquipmentCriteria(request)
    .then(function(selected){
        
        if (selected != undefined && selected.length>0) {
            selected = selected[0]
            vm.referenceno = selected.ReferenceDocumentNo;
            vm.depotOrderId = selected.DepotOrderId;
            vm.depotOrderNo = selected.DepotOrderNo;
            vm.referenceDocumentNo = selected.ReferenceDocumentNo;
            vm.vesselId = selected.VesselId;
            vm.voyageId = selected.VoyageId;
            vm.IsChangeDepot = selected.IsChangeDepot;
            vm.customerId = selected.CustomerId;
            vm.carrierId = selected.CarrierId;
            vm.yardScheduleHourDetailPersonalizes = selected.YardScheduleHourDetailPersonalizeIsAvailables
            $('#depot_order_value').val(selected.DepotOrderNo);
            $('#customer_ref').val(selected.CustomerName);
            $('#carrier_ref').val(selected.CarrierName);

            validateSearchEquipments();
        }else{
            toastr.error($translate.instant('views.appointment.referenceDocumentNoNotFound').replace("{0}", vm.currentCustomerService.Aditional));
            return false;
        }

    },function(){
        toastr.error($translate.instant('views.appointment.referenceDocumentNoNotFound').replace("{0}", vm.currentCustomerService.Aditional));
        return false;
    })
}
    //grilla para crear conductor
    vm.gridOptions1 = {
        height: 100,
        enableColResize: true,
        enableFilter: true,
        rowData: null,
        columnDefs: columnDefs1,
        suppressRowClickSelection: true,
        ready: function (api) {
            api.api.showLoading(false);
        }
    };

        //grilla para crear Placa
        vm.grdTruckDocumentTypes = {
            height: 100,
            enableColResize: true,
            enableFilter: true,
            rowData: null,
            columnDefs: columnTruckDocumentTypes,
            suppressRowClickSelection: true,
            ready: function (api) {
                api.api.showLoading(false);
            }
        };

        //grilla contenedora de equipos de varias depotorders
        vm.gridOptions2 = {
            enableColResize: true,
            enableFilter: true,
            rowData: null,
            rowSelection: 'multiple',
            columnDefs: columnDefs2,
            suppressRowClickSelection: true,
            cellClicked: cellClickedfunct,
            ready: function (api) {
                api.api.showLoading(false);
            }
        };

        //grilla agrupadora cuando son citas multiples
        vm.gridOptions3 = {
            enableColResize: true,
            enableFilter: true,
            rowData: null,
            columnDefs: columnDefs3,
            suppressRowClickSelection: true,
            ready: function (api) {
                api.api.showLoading(false);
            }
        };

        //grilla con informacion de depot order
        vm.gridOptions4 = {
            enableColResize: true,
            enableFilter: true,
            rowData: null,
            columnDefs: columnDefs4,
            suppressRowClickSelection: true,
            ready: function (api) {
                api.api.showLoading(false);
            }
        };

        init();

        function customMultipleDatesEditor(params) {
            var setSelectionOptions = vm.MultipleDatesTotal;
            var editing = false;
            var eCell = document.createElement('div');            
            var eLabel = document.createTextNode(params.data.PeriodPerAppt);
            
            eCell.appendChild(eLabel);

            var eSelect = document.createElement("select");
            setSelectionOptions.forEach(function (item) {
                var eOption = document.createElement("option");
                eOption.setAttribute("value", item);
                eOption.innerHTML = item;
                eSelect.appendChild(eOption);
            });

            eSelect.value = params.value;

            eCell.addEventListener('click', function () {

                if (!editing) {
                    eCell.removeChild(eLabel);
                    eCell.appendChild(eSelect);
                    eSelect.focus();
                    editing = true;
                }
            });

            eSelect.addEventListener('blur', function () {

                if (editing) {
                    editing = false;
                    eCell.removeChild(eSelect);
                    eCell.appendChild(eLabel);
                }
            });

            eSelect.addEventListener('change', function () {


                if (editing) {
                    editing = false;
                    var newValue = eSelect.value;
                    params.data[params.colDef.field] = newValue;
                    eLabel.nodeValue = newValue;
                    eCell.removeChild(eSelect);
                    eCell.appendChild(eLabel);
                }
            });
            return eCell;
        }

        function customEditor(params) {
            var setSelectionOptions = ['1', '2'];
            if (params.data.SizeValue == 40)
                setSelectionOptions = ['1'];            

            var editing = false;
            var eCell = document.createElement('div');
            var eLabel = document.createTextNode("1");
            eCell.appendChild(eLabel);

            var eSelect = document.createElement("select");
            setSelectionOptions.forEach(function (item) {
                var eOption = document.createElement("option");
                eOption.setAttribute("value", item);
                eOption.innerHTML = item;
                eSelect.appendChild(eOption);
            });

            eSelect.value = params.value;
            eCell.addEventListener('click', function () {
                if (!editing) {
                    eCell.removeChild(eLabel);
                    eCell.appendChild(eSelect);
                    eSelect.focus();
                    editing = true;
                }
            });

            eSelect.addEventListener('blur', function () {
                if (editing) {
                    editing = false;
                    eCell.removeChild(eSelect);
                    eCell.appendChild(eLabel);
                }
            });

            eSelect.addEventListener('change', function () {
                if (editing) {
                    editing = false;
                    var newValue = eSelect.value;
                    params.data[params.colDef.field] = newValue;
                    eLabel.nodeValue = newValue;
                    eCell.removeChild(eSelect);
                    eCell.appendChild(eLabel);
                }
            });

            return eCell;
        }

        function loadAppConfig() {
            var dataloaded = vm.gridOptions.rowData;
            var foundTruckerDriver = false;
            var foundTruckerPlate = false;

            $(dataloaded).each(function (a, row) {
                if (row.OperationTypeMovementCode && row.OperationTypeMovementCode.length > 0) {
                    for (var i in vm.truckerDriverAllowed) {
                        if (vm.truckerDriverAllowed[i].Name == row.OperationTypeMovementCode) {
                            vm.truckerDriverRequired = true;
                            foundTruckerDriver = true;
                            break;
                        }
                    }

                    for (var i in vm.truckerPlateAllowed) {
                        if (vm.truckerPlateAllowed[i].Name == row.OperationTypeMovementCode) {
                            vm.truckerPlateRequired = true;
                            foundTruckerPlate = true;
                            break;
                        }
                    }
                }
            });

            if (!foundTruckerDriver)
                vm.truckerDriverRequired = false;

            if (!foundTruckerPlate)
                vm.truckerPlateRequired = false;

            ShowOrHideLink();
        }

        function evaluteComboRelation(row) {
            var foundTruckerDriver = false;
            var foundTruckerPlate = false;

            for (var i in vm.truckerDriverAllowed) {
                if (vm.truckerDriverAllowed[i].Name == row.OperationTypeMovementCode) {
                    vm.truckerDriverRequired = true;
                    foundTruckerDriver = true;
                    break;
                }
            }

            if (!foundTruckerDriver)
                vm.truckerDriverRequired = false;

            for (var i in vm.truckerPlateAllowed) {
                if (vm.truckerPlateAllowed[i].Name == row.OperationTypeMovementCode) {
                    vm.truckerPlateRequired = true;
                    foundTruckerPlate = true;
                    break;
                }
            }

            if (!foundTruckerPlate)
                vm.truckerPlateRequired = false;

            ShowOrHideLink();
        }

        function userRolIsTrucker() {
            let authInformation = common.localStorageService.get('authorizationData');
            let currentRole = authInformation ? authInformation.userRole : "";
            let isOnlyPortalUser = authInformation ? authInformation.isOnlyPortalUser : false;
            return currentRole === vm.TruckerBPRoleCode && isOnlyPortalUser ? true : false;
        }

        function userRolIsShipper() {
            let authInformation = common.localStorageService.get('authorizationData');
            let currentRole = authInformation ? authInformation.userRole : "";
            let isOnlyPortalUser = authInformation ? authInformation.isOnlyPortalUser : false;
            return currentRole === vm.ShipperBPRoleCode && isOnlyPortalUser ? true : false;
        }

        function moveRow(depotOrderEquipmentId) {
            if (vm.isEdit === true && vm.isEditDisabled === true) 
                return;

            var row = angular.copy($(vm.gridOptions.rowData).filter(function (e, v) { return v.DepotOrderEquipmentId == depotOrderEquipmentId; })[0]);

            if(vm.yardScheduleHourDetailPersonalizes){
                var depotOrderSummary = vm.yardScheduleHourDetailPersonalizes.find(x => x.HasYardScheduleHourDetailPersonalize 
                    && x.IsAvailable && x.DepotOrderSummaryId == row.DepotOrderSummaryId);
                if(depotOrderSummary != null && depotOrderSummary.UsedAppointmentQuantity >= (depotOrderSummary.AvailableQuantity + 1)){
                    var message = $translate.instant('views.appointment.msgValidateByScheduleHourDetailPersonalize')
                    return toastr.warning(message);
                }
                else{
                    var depotOrderSummaryDto = vm.yardScheduleHourDetailPersonalizes.map(x => {
                        if(x.HasYardScheduleHourDetailPersonalize 
                            && x.IsAvailable && x.DepotOrderSummaryId == row.DepotOrderSummaryId)
                            x.UsedAppointmentQuantity += 1;
    
                            return x;
                    });
                    vm.yardScheduleHourDetailPersonalizes = depotOrderSummaryDto;
                }
    
                var depotOrderSummary = vm.yardScheduleHourDetailPersonalizes.find(x => !x.IsAvailable && x.DepotOrderSummaryId == row.DepotOrderSummaryId);
                if(depotOrderSummary != null && !depotOrderSummary.IsAvailable)
                    return toastr.warning(depotOrderSummary.Message);
    
                row.YardScheduleHourId = $window.sessionStorage.yardScheduleHourId;
            }
            
            var rowIndex = 0;
            $(vm.gridOptions.rowData).each(function (index, item) {
                if (item.DepotOrderEquipmentId == depotOrderEquipmentId)
                    rowIndex = index;
            });

            if (vm.isMultiple == true) {
                if (!vm.selectedTruckerId) {
                    toastr.info($translate.instant('views.appointment.fieldTrucker'));
                    $('#trucker_value').removeAttr('disabled');
                    $('#rutTrucker_value').removeAttr('disabled');
                    
                    if (userRolIsTrucker()) {
                        $('#trucker_value').attr('disabled', 'disabled');
                        $('#rutTrucker_value').attr('disabled', 'disabled');
                    }
                    return false;
                }

                if (!vm.selectedDriverId) {
                    if (vm.truckerDriverRequired == true)
                        toastr.info($translate.instant('views.appointment.youCanOnlySelectADriverThatIsRelatedWithTheTrucker'));
                    else
                        toastr.info($translate.instant('views.appointment.enterDriverIfYouNeedToAddANewDriverClickAddButton'));

                    return false;
                }

                vm.placa = angular.copy($('#placa_value').val());
                if (!vm.placa) {
                    toastr.info($translate.instant('views.appointment.insertPlate'));
                    return false;
                }

                if ($(vm.gridOptions2.rowData).length == 0)
                vm.gridOptions2.columnApi.hideColumn('PeriodPerAppt', false);                

                row.PeriodPerAppt = vm.MultipleDatesTotal[0];

                if (row.OperationTypeMovementCode && row.OperationTypeMovementCode.length > 0 && vm.isMultiple == true)
                    evaluteComboRelation(row);                                

                row.MultipleTruckerId = angular.copy(vm.selectedTruckerId);
                row.MultipleTruckerName = angular.copy($('#trucker_value').val());
                row.MultipleDriverId = angular.copy(vm.selectedDriverId);
                row.MultipleDriverName = angular.copy($('#driver_value').val());
                row.MultiplePlate = angular.copy(vm.placa);

                if ($(vm.gridOptions2.rowData).length == 0) {
                    vm.gridOptions2.columnApi.hideColumn('MultipleTruckerName', false);
                    vm.gridOptions2.columnApi.hideColumn('MultipleDriverName', false);
                    vm.gridOptions2.columnApi.hideColumn('MultiplePlate', false);
                }
            }
            else {
                vm.gridOptions2.columnApi.hideColumn('MultipleTruckerName', true);
                vm.gridOptions2.columnApi.hideColumn('MultipleDriverName', true);
                vm.gridOptions2.columnApi.hideColumn('MultiplePlate', true);
                row.MultipleTruckerName = '';
                row.MultipleDriverName = '';
                row.placa = '';
            }
            
            //determinar que validacion se aplica para empresa/conductor y empresa/placa para cada depot agregada
            if (row.OperationTypeMovementCode && row.OperationTypeMovementCode.length > 0 && vm.isMultiple == false) {
                $('#trucker_value').removeAttr('disabled');
                $('#rutTrucker_value').removeAttr('disabled');
                
                if (userRolIsTrucker()) {
                    $('#trucker_value').attr('disabled', 'disabled');
                    $('#rutTrucker_value').attr('disabled', 'disabled');
                }
                evaluteComboRelation(row);
            }

            if (row.EquipmentNo == null && vm.varactiontype == 'D') {
                toastr.info($translate.instant('views.appointment.youCannotAddEquipmentsUnassignedInTheGateIn'));
                return false;
            }

            var newRows = [];
            if (vm.gridOptions2.rowData != null) {
                newRows = vm.gridOptions2.rowData;
            }
            var existsInBottomGrid = IsNonScheduledRequestedEquipmentInBottomGrid(row.DepotOrderId, row.DepotOrderEquipmentId);
            if (!existsInBottomGrid) {
                newRows.push(row);
                vm.gridOptions2.rowData = angular.copy(newRows);
                vm.gridOptions2.api.onNewRows();

                var rowsInTop = vm.gridOptions.rowData;
                if (datappointments != null) {
                    var rowToDelete = 0;
                    for (var x = 0; x < datappointments.length; x++) {
                        if (datappointments[x].DepotOrderEquipmentId == row.DepotOrderEquipmentId) {
                            rowToDelete = x;
                        }
                    }
                    datappointments.splice(rowToDelete, 1);

                    rowsInTop.splice(rowIndex, 1);
                    vm.gridOptions.rowData = rowsInTop;
                    vm.gridOptions.api.onNewRows();
                    cambiarColorFilasDeshabilitadas();
                }
            } else
                toastr.info($translate.instant('views.appointment.TheEquipmentHasAlreadyBeenAdded'));
        }

        function deleteRow(appointmentId, appointmentEquipmentId, depotOrderId, depotOrderEquipmentId) {
            var row;
            var rowIndex = 0;

            if (IsRequestedEquipmentAlreadyScheduled(appointmentEquipmentId)) {
                if (IsRequestedEquipmentScheduledInCurrentAppointment(appointmentId)) {
                    row = GetRowOfScheduledRequestedEquipmentInBottomGrid(appointmentEquipmentId);

                    rowIndex = GetRowIndexOfScheduledRequestedEquipmentInBottomGrid(appointmentEquipmentId);

                    MoveRowOfScheduledRequestedEquipmentFromBottomToTopGrid(row, rowIndex);
                }
            }
            else {
                row = GetRowOfNonScheduledRequestedEquipmentInBottomGrid(depotOrderId, depotOrderEquipmentId);

                rowIndex = GetRowIndexOfNonScheduledRequestedEquipmentInBottomGrid(depotOrderId, depotOrderEquipmentId);

                MoveRowOfNonScheduledRequestedEquipmentFromBottomToTopGrid(row, rowIndex);

            }

            if(vm.yardScheduleHourDetailPersonalizes != null){
                var depotOrderSummaryDto = vm.yardScheduleHourDetailPersonalizes.map(x => {
                    if(x.HasYardScheduleHourDetailPersonalize 
                        && x.IsAvailable && x.DepotOrderSummaryId == row.DepotOrderSummaryId)
                        x.UsedAppointmentQuantity -= 1;
    
                        return x;
                });
                vm.yardScheduleHourDetailPersonalizes = depotOrderSummaryDto;
            }

            if ((vm.gridOptions2.rowData && vm.gridOptions2.rowData.length == 0) || vm.gridOptions2.rowData == null) {
               
                clearDriverPlate('DP', 'D');
                if (!userRolIsTrucker()) {
                    vm.selectedTruckerId = null;
                    vm.selectedTruckerRut = null;
                    $('#trucker_value').attr('disabled', 'disabled');
                    $('#trucker_value').val('');
                    $('#rutTrucker_value').attr('disabled', 'disabled');
                    $('#rutTrucker_value').val('');
                    $('#rut_value').val('');
                    $('#rut_value').attr('disabled', 'disabled');
                } else {
                    
                    $('#driver_value').removeAttr('disabled');
                    $('#rut_value').removeAttr('disabled');
                    //$('#rut_value').attr('disabled', 'disabled');
                }
            }

            cambiarColorFilasDeshabilitadas();

            if ($(vm.gridOptions2.rowData).length > 0) {
                if ($(vm.gridOptions2.rowData)[0].DepotOrderId > 0)
                    vm.DepotOrderId = angular.copy($(vm.gridOptions2.rowData)[0].DepotOrderId);
                vm.depotOrderId = $(vm.gridOptions2.rowData)[0].DepotOrderId;
            }
            
            blockTruckerControls();
            setDefaultTrucker();

        }

        function GetRowOfScheduledRequestedEquipmentInBottomGrid(appointmentEquipmentId) {
            return angular.copy($(vm.gridOptions2.rowData).filter(function (e, v) { return v.AppointmentEquipmentId == appointmentEquipmentId; })[0]);
        }

        function GetRowOfNonScheduledRequestedEquipmentInBottomGrid(depotOrderId, depotOrderEquipmentId) {
            return angular.copy($(vm.gridOptions2.rowData).filter(function (e, v) { return v.DepotOrderId == depotOrderId && v.DepotOrderEquipmentId == depotOrderEquipmentId; })[0]);
        }

        function GetRowIndexOfScheduledRequestedEquipmentInBottomGrid(appointmentEquipmentId) {
            var rowIndex = 0;
            $(vm.gridOptions2.rowData).each(function (index, item) {
                if (item.AppointmentEquipmentId == appointmentEquipmentId)
                    rowIndex = angular.copy(index);
            });

            return rowIndex;
        }

        function GetRowIndexOfNonScheduledRequestedEquipmentInBottomGrid(depotOrderId, depotOrderEquipmentId) {
            var rowIndex = 0;
            $(vm.gridOptions2.rowData).each(function (index, item) {
                if (item.DepotOrderId == depotOrderId && item.DepotOrderEquipmentId == depotOrderEquipmentId)
                    rowIndex = angular.copy(index);
            });

            return rowIndex;
        }

        function MoveRowOfScheduledRequestedEquipmentFromBottomToTopGrid(row, rowIndex) {
            AddRowToTopGrid(row);
            DeleteRowFromBottomGrid(rowIndex);
        }

        function MoveRowOfNonScheduledRequestedEquipmentFromBottomToTopGrid(row, rowIndex) {
            AddRequestedEquipmentToRequestedEquipmentList(row);
            AddRowToTopGrid(row);
            DeleteRowFromBottomGrid(rowIndex);
        }

        function AddRequestedEquipmentToRequestedEquipmentList(row) {
            if (datappointments == null)
                return;

            if ($("#depot_order_value").val() == row.DepotOrderNo)
                datappointments.push(row);
        }

        function AddRowToTopGrid(row) {
            if (datappointments == null)
                return;

            var newRows = vm.gridOptions.rowData;
            if ($("#depot_order_value").val() == row.DepotOrderNo) {
                newRows.push(row);
                vm.gridOptions.rowData = newRows;
                vm.gridOptions.api.onNewRows();
            }
        }

        function DeleteRowFromBottomGrid(rowIndex) {
            var rowsDw = angular.copy(vm.gridOptions2.rowData);
            if (rowsDw != null) {
                rowsDw.splice(rowIndex, 1);
                vm.gridOptions2.rowData = angular.copy(rowsDw);
                vm.gridOptions2.api.onNewRows();
            }
        }

        function init() {
            common.activateController([getDocumentTypes(), initialReferenceData(), getDepotOrderSearchSetting(), getEquipmentSizeTypeIdsRestriction(), getDriverDocuments(), getTruckerDriverPlateConfiguration("D"), getTruckerDriverPlateConfiguration("P"), getTruckDocuments()])
                .then(function (data) {
                    vm.equipmentsizeAllow1 = vm.equipmentsizeAllow1;
                    vm.equipmentsizeAllow2 = vm.equipmentsizeAllow2;

                    var authData = common.localStorageService.get('authorizationData');
                    vm.roleSelected = authData ? authData.userRole : "";
                    vm.isOnlyPortalUser = authData ? authData.isOnlyPortalUser : false;

                    //en sessionStorage los bools vienen como cadena
                    //solo deshabilita los campos en la edicion 
                    var apIdToEdit = $window.sessionStorage.appointmentId;
                    vm.isEditDisabled = false;

                    if (apIdToEdit != null && apIdToEdit > 0) {
                        if ($window.sessionStorage.editDisabled != null) {
                            var b = $window.sessionStorage.editDisabled;
                            if (b === "true" || b === true)
                                vm.isEditDisabled = true;
                            else
                                vm.isEditDisabled = false;
                        }
                    }

                    if (data[4]) {
                        vm.driverdocuments = data[4].DriverRoleTypeDocuments[0].RolTypeDTDTO;
                        vm.driverdocumentsgrid = [];

                        var driverRutDocument;
                        var rutIndex = null;
                        //RUT primer registro
                        for (var dd in vm.driverdocuments) {
                            if (vm.driverdocuments[dd].DocumentType == 'RUT') {
                                rutIndex = dd;
                                driverRutDocument = vm.driverdocuments[dd];
                            }
                        }

                        if (rutIndex && driverRutDocument) {
                            vm.driverdocuments.splice(rutIndex, 1);
                            vm.driverdocumentsgrid.push({
                                "RoleTypeId": driverRutDocument.RoleTypeId, "DocumentTypeId": driverRutDocument.DocumentTypeId, "DocumentType": driverRutDocument.DocumentType, "MandatoryT": driverRutDocument.MandatoryT, "MandatoryExpirationDateT": driverRutDocument.MandatoryExpirationDateT, "DocumentName": driverRutDocument.Name, "DocumentNumber": "", "StartDateString": "", "ExpirationDateString": ""
                            });
                        }

                        for (var dd in vm.driverdocuments) {
                            vm.driverdocumentsgrid.push({
                                "RoleTypeId": vm.driverdocuments[dd].RoleTypeId, "DocumentTypeId": vm.driverdocuments[dd].DocumentTypeId, "DocumentType": vm.driverdocuments[dd].DocumentType, "MandatoryT": vm.driverdocuments[dd].MandatoryT, "MandatoryExpirationDateT": vm.driverdocuments[dd].MandatoryExpirationDateT, "DocumentName": vm.driverdocuments[dd].Name, "DocumentNumber": "", "StartDateString": "", "ExpirationDateString": ""
                            });
                        }
                        createNewDatasourceDocumentos();
                        
                    }
                    if (data[7]) {
                        vm.truckdocumentsgrid = data[7].TruckDocumentTypeTrucks;

                        createNewDatasourcePlateNoDocuments();
                    }
                    $('#appointmentCreateDriver').on('hidden.bs.modal', function () { clearDocuments(); });
                    $('#appointmentCreatePlateNo').on('hidden.bs.modal', function () { clearTruckDocuments(); });

                    $('#depot_order_value').keyup(function (e) {
                        if (e.keyCode == 8 || e.keyCode == 46)
                            vm.limpiaBusquedaEquipos('dep');
                    });

                    $('#referenceno_value').keyup(function (e) {
                        if (e.keyCode == 8 || e.keyCode == 46)
                            vm.limpiaBusquedaEquipos('ref');
                    });

                    var regex = new RegExp("^[0-9]{7,20}$");
                    $('#txtTelefono').blur(function () {
                        if (!regex.test($(this).val())) {
                            $(this).val('');
                            toastr.info($translate.instant('views.appointment.EnterOnly7To20Characters'));
                            return false;
                        }
                    });

                    if (vm.isEdit === true && vm.isEditDisabled === true)
                        $("#txtSearch").attr('disabled', 'disabled');
                },
                    function (err) {
                        if (err.status)
                            toastr.error(err.info);
                    });
        }

        //valida mm/dd/yyyy
        function validDateString(fecha) {            
            var date_regex = /^(0[1-9]|1\d|2\d|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/;
            if (!(date_regex.test(fecha)))
                return false;
            else
                return true;
        }

        function getDateFromStringForView(fechaString, tipo) {
            if (tipo == "default") {
                if (fechaString && fechaString.length > 2) {
                    var fpartes = fechaString.split("/");
                    if (fpartes.length && fpartes.length > 0)
                        return fpartes[0] + "/" + fpartes[1] + "/" + fpartes[2];                    
                }
                return "";
            } else {
                if (fechaString && fechaString.length > 2) {
                    var fpartes = fechaString.split("/");
                    if (fpartes.length && fpartes.length > 0)
                        return fpartes[1] + "/" + fpartes[0] + "/" + fpartes[2];
                }
                return "";
            }
        }

        function docNumValueHandler(params) {

            var origStr = params.newValue;
            var regex = new RegExp("^[a-zA-Z0-9]{3,15}$");

            if (regex.test(origStr) || origStr == "") {
                params.data[params.colDef.field] = origStr;
            } else {
                $(this).val('');
                toastr.info($translate.instant('views.appointment.EnterUpto15numbersAndOrLetters'));
                return false;
            }

        }

        //asegura las fechas en el formato dd/mm/yyyy
        function datesValueHandler(params) {
            var origDateStr = params.newValue;
            var dmyDateStr = getDateFromStringForView(origDateStr, "normal");

            if ((new Date(dmyDateStr) !== "Invalid Date" && !isNaN(new Date(dmyDateStr)) && validDateString(origDateStr)) || (dmyDateStr == "")) {
                //al grabar debe voltear para que se considere fecha correcta
                params.data[params.colDef.field] = origDateStr;
            } else
                toastr.info($translate.instant('views.appointment.InvalidDateDueToFormat'));
        }

        function cambiarColorFilasDeshabilitadas() {
            var rowsInTop = vm.gridOptions.rowData;
            for (var rowIndex in rowsInTop) {
                if (rowsInTop[rowIndex].IsDisabled || (IsRequestedEquipmentAlreadyScheduled(rowsInTop[rowIndex].AppointmentEquipmentId) && !IsRequestedEquipmentScheduledInCurrentAppointment(rowsInTop[rowIndex].AppointmentId))) {
                    $("div[ag-grid='vm.gridOptions']  div[row='" + rowIndex + "']").css('color', '#AAAAAA');
                }
            }
        }

        function deshabilitarSeleccionFilas(rowIdx) {
        }

        //arma el elemento para la grilla agrupada
        vm.checked = function(){
            
            vm.showAll = $("#chkSelectAll").prop("checked")
            createNewDatasource(false)

        }
        
        function newGroupedItem(row) {
            var equipment = { 
                "DepotOrderEquipmentId": row.DepotOrderEquipmentId, 
                "DepotOrderSummaryId": row.DepotOrderSummaryId, 
                "QuantityToSchedule": row.QuantityToSchedule };
            return equipment;
        }

        var firstTimeOnEdit = true;
        function createNewDatasource(isEdit) {
            var datatobind = [];
            var datatogroupedbind = [];

            //para el create
            if (!isEdit)
                firstTimeOnEdit = false;

            if (!firstTimeOnEdit) {
                if (!datappointments) return;                                    

                for (var apt in datappointments) {
                    if (vm.showAll) {
                        if (IsRequestedEquipmentAlreadyScheduled(datappointments[apt].AppointmentEquipmentId)) {
                            if (IsRequestedEquipmentScheduledInCurrentAppointment(datappointments[apt].AppointmentId)) {
                                if (IsScheduledRequestedEquipmentInBottomGrid(datappointments[apt].AppointmentEquipmentId))
                                    continue;
                                else
                                    datatobind.push(datappointments[apt]);
                            }
                            else
                                datatobind.push(datappointments[apt]);
                        }
                        else {
                            if (IsNonScheduledRequestedEquipmentInBottomGrid(datappointments[apt].DepotOrderId, datappointments[apt].DepotOrderEquipmentId))
                                continue;
                            else
                                datatobind.push(datappointments[apt]);
                        }
                    }
                    else {
                        if (datappointments[apt].IsDisabled)
                        {
                            continue;
                        }

                        if (IsRequestedEquipmentAlreadyScheduled(datappointments[apt].AppointmentEquipmentId)) {
                            if (IsRequestedEquipmentScheduledInCurrentAppointment(datappointments[apt].AppointmentId)) {
                                if (IsScheduledRequestedEquipmentInBottomGrid(datappointments[apt].AppointmentEquipmentId))
                                    continue;
                                else
                                    datatobind.push(datappointments[apt]);
                            }

                            if (!IsRequestedEquipmentScheduledInCurrentAppointment(datappointments[apt].AppointmentId)) {
                                continue;
                            }
                        }
                        else {
                            if (IsNonScheduledRequestedEquipmentInBottomGrid(datappointments[apt].DepotOrderId, datappointments[apt].DepotOrderEquipmentId))
                                continue;
                            else
                                datatobind.push(datappointments[apt]);
                        }
                    }
                }
            }

            //si la data del appointment recuperado no existe indicarlo

            //solo en la primera en la carga del Edit
            if (firstTimeOnEdit) {
                if (!datappointment) return;                    
                datatobind = datappointment.AppointmentEquipments;
            }

            //generacion de datagrupada
            //solo se agruparan los que esten habilitados para ser usados            
            var groupedItem = {};
            var sizeTypeIds = [];
            var assignedEquipments = 0;
            for (var i = 0; i < datatobind.length; i++) {
                if ($.inArray(datatobind[i].EquipmentSizeTypeId, sizeTypeIds) == -1 && datatobind[i].EquipmentSizeTypeId != null) {
                    sizeTypeIds.push(datatobind[i].EquipmentSizeTypeId);
                }
                //contar los equipos asignados (con numero de equipo), la grilla agrupada solo se muestra cuando no hay ningun asignado
                if (datatobind[i].EquipmentNo != null && datatobind[i].EquipmentNo.length > 0)
                    assignedEquipments++;
            }

            //armo el objeto en base al sizeType como Id
            for (var i = 0; i < sizeTypeIds.length; i++) {
                var nroSizeTypes = 0;
                var nroUsedEquipments = 0;
                var sizeTypeName = "";
                var sizeValue = 0;
                var depotOrderNo = ""; var depotOrderId = 0;

                //de los habiles para agendar (datatobind) se cuenta el numero de sizeTypes para agruparlos
                //ademas si alguno tiene nro de equipo (es asignado) se usa la grilla normal
                //si ninguno tiene numero de equipo entonces se usa la grilla agrupada cuando es citaMultiple                                
                if (datatobind && datatobind.length > 0) {
                    for (var j = 0; j < datatobind.length; j++) {
                        if (sizeTypeIds[i] == datatobind[j].EquipmentSizeTypeId) {
                            sizeTypeName = datatobind[j].SizeTypeName;
                            sizeValue = datatobind[j].SizeValue;
                            depotOrderNo = datatobind[j].DepotOrderNo;
                            depotOrderId = datatobind[j].DepotOrderId;
                            nroSizeTypes++;
                        }
                    }
                }

                //contar los ya agendados(utilizados y no mostrados) del total
                if (datappointments && datappointments.length > 0) {
                    for (var j = 0; j < datappointments.length; j++) {
                        if (sizeTypeIds[i] == datappointments[j].EquipmentSizeTypeId) {
                            //se agrego el null como equipos usados                            
                            if ((datappointments[j].StatusCode == "PE" || datappointments[j].InGate == true || datappointments[j].IsDisabled == true))
                                nroUsedEquipments++;                            
                        }
                    }
                }

                if (datappointments) {
                    groupedItem =
                        {
                            "SizeTypeId": sizeTypeIds[i],
                            "SizeTypeName": sizeTypeName,
                            "SizeValue": sizeValue,
                            "SizeTypeQnt": nroSizeTypes,
                            "ScheduledEquipments": 0,
                            "UsedEquipments": nroUsedEquipments,
                            "TotalEquipments": datatobind,
                            "DepotOrderNo": depotOrderNo,
                            "DepotOrderId": depotOrderId,
                            "OperationTypeMovementCode": datappointments[0].OperationTypeMovementCode
                        };
                }
                else {
                    groupedItem =
                        {
                            "SizeTypeId": sizeTypeIds[i],
                            "SizeTypeName": sizeTypeName,
                            "SizeValue": sizeValue,
                            "SizeTypeQnt": nroSizeTypes,
                            "ScheduledEquipments": 0,
                            "UsedEquipments": nroUsedEquipments,
                            "TotalEquipments": datatobind,
                            "DepotOrderNo": depotOrderNo,
                            "DepotOrderId": depotOrderId
                        };
                }

                datatogroupedbind.push(groupedItem);
            }

            //bien, queda cargando por que en el load se le setean lista que nunca se llena
            //desactivar la carga
            if (vm.isMultiple && assignedEquipments == 0) {
                if ($(datatogroupedbind).length > 0) {
                    var row = $(datatogroupedbind)[0];
                    
                    $('#trucker_value').removeAttr('disabled');
                    $('#rutTrucker_value').removeAttr('disabled');
                    var foundTruckerDriver = false;
                    var foundTruckerPlate = false;

                    if (row.OperationTypeMovementCode && row.OperationTypeMovementCode.length > 0) {
                        for (var i in vm.truckerDriverAllowed) {
                            if (vm.truckerDriverAllowed[i].Name == row.OperationTypeMovementCode) {
                                vm.truckerDriverRequired = true;
                                foundTruckerDriver = true;
                                break;
                            }
                        }

                        if (!foundTruckerDriver)
                            vm.truckerDriverRequired = false;

                        for (var i in vm.truckerPlateAllowed) {
                            if (vm.truckerPlateAllowed[i].Name == row.OperationTypeMovementCode) {
                                vm.truckerPlateRequired = true;
                                foundTruckerPlate = true;
                                break;
                            }
                        }

                        if (!foundTruckerPlate)
                            vm.truckerPlateRequired = false;
                    }
                }
                else {
                    if ($(vm.gridOptions2.rowData).length == 0) {
                        $('#rutTrucker_value').attr('disabled', 'disabled');
                        vm.truckerDriverRequired = false;
                        vm.truckerPlateRequired = false;
                    }
                }

                ShowOrHideLink();
                
                //deben esconderse las grillas segun los datos que hayan resultado (si son para agruparse o no)
                //si hay datos agrupados muestra grilla agrupada si no es gatein
                //si es gatein no puede mostrar la grilla agrupada
                if (datatogroupedbind.length > 0 && vm.varactiontype != "D" && false) {
                    vm.gridMultipleVisible = true;
                    $('#ddlequipmentsperappt').css("visibility", "hidden");
                    $('#showAll').css("visibility", "hidden");
                    $("div[ag-grid='vm.gridOptions']").hide();
                    $("div[ag-grid='vm.gridOptions2']").hide();
                    $("div[ag-grid='vm.gridOptions3']").show();
                    vm.gridOptions3.rowData = datatogroupedbind;
                    vm.gridOptions3.api.onNewRows();
                } else {
                    //si no hay entonces habilita la grilla normal para que bindeee los datos normalmente de existir
                    //mas abajo                    
                    vm.gridMultipleVisible = false;
                    $('#divequipmentsperappt').css("visibility", "visible");
                    $('#showAll').css("visibility", "visible");

                    $("div[ag-grid='vm.gridOptions']").show();
                    $("div[ag-grid='vm.gridOptions2']").show();
                    $("div[ag-grid='vm.gridOptions3']").hide();
                }
            } else if (vm.isMultiple && assignedEquipments > 0){
                $('#trucker_value').removeAttr('disabled');
                $('#rutTrucker_value').removeAttr('disabled');
            }else {                
                vm.gridMultipleVisible = false;
                $('#showAll').css("visibility", "visible");
                if (vm.isMultiple && assignedEquipments > 0) {
                    $('#divequipmentsperappt').css("visibility", "visible");
                } else {
                    $('#divequipmentsperappt').css("visibility", "hidden");
                }

                //blanquea la grilla agrupada para que no se considere en la validacion de sitypesids
                vm.gridOptions3.rowData = [];
                vm.gridOptions3.api.onNewRows();
                $("div[ag-grid='vm.gridOptions']").show();
                $("div[ag-grid='vm.gridOptions2']").show();
                $("div[ag-grid='vm.gridOptions3']").hide();
            }

            //si no es la primera vez en Edit entonces carga siempre en la primera grilla normalmente despues de una busqueda de depot
            if (!firstTimeOnEdit) {
                vm.gridOptions.rowData = datatobind;
                vm.gridOptions.api.onNewRows();
                cambiarColorFilasDeshabilitadas();

            } else {
                //solo si es la primera vez y es Edit carga de frente en la segunda grilla
                vm.gridOptions2.rowData = datatobind;
                vm.gridOptions2.api.onNewRows();
            }
            ShowOrHideLink();

        }

        function IsRequestedEquipmentAlreadyScheduled(appointmentEquipmentId) {
            return appointmentEquipmentId > 0;
        }

        function IsRequestedEquipmentScheduledInCurrentAppointment(appointmentId) {
            return appointmentId == vm.appointmentId;
        }

        function IsScheduledRequestedEquipmentInBottomGrid(appointmentEquipmentId) {
            var row = $(vm.gridOptions2.rowData).filter(function (e, requestedEquipment) { return requestedEquipment.AppointmentEquipmentId == appointmentEquipmentId });

            return row.length > 0;
        }

        function IsNonScheduledRequestedEquipmentInBottomGrid(depotOrderId, depotOrderEquipmentId) {
            var row = $(vm.gridOptions2.rowData).filter(function (e, requestedEquipment) { return requestedEquipment.DepotOrderId == depotOrderId && requestedEquipment.DepotOrderEquipmentId == depotOrderEquipmentId });

            return row.length > 0;
        }

        function createNewDatasourceDocumentos() {
            if (vm.driverdocumentsgrid) {
                vm.gridOptions1.rowData = vm.driverdocumentsgrid;
                if (vm.gridOptions1.api)
                    vm.gridOptions1.api.onNewRows();
            }
        }

        function createNewDatasourcePlateNoDocuments() {
            if (vm.truckdocumentsgrid) {
                vm.grdTruckDocumentTypes.rowData = vm.truckdocumentsgrid;
                if (vm.grdTruckDocumentTypes.api)
                    vm.grdTruckDocumentTypes.api.onNewRows();
            }
        }
        
        function initialReferenceData() {
            return datacontext.appointment.getFilters().then(function (data) {
                //normal o multiple
                vm.apptsInfo = common.localStorageService.get('apptsInfo').apptsinfo;
                vm.varyard = common.localStorageService.get('selectedYard').yard;
                vm.customerServices = common.localStorageService.get('GetBusinessPartnerUserRolesQuery').CustomerServices;
                vm.currentCustomerService = vm.customerServices.find(x => x.Id == vm.varyard);
                vm.currentCustomerService = vm.currentCustomerService != null 
                    ? vm.currentCustomerService 
                    : vm.customerServices.find(x => x.Code == 'CLSAICT');
                vm.yardsList = data.AllYards;

                vm.varactiontype = $window.sessionStorage.codeActionType;
                vm.actiontypeList = data.ActionTypes;
                vm.varoperationtype = $window.sessionStorage.codeOperationType;

                if ((typeof vm.apptsInfo == 'undefined' || vm.apptsInfo == null) || (vm.apptsInfo && vm.apptsInfo.length == 0)) {
                    vm.appointmentId = $window.sessionStorage.appointmentId; /*change*/
                    vm.appointmentTemplateId = angular.copy($rootScope.__AppointmentTemplateId__); /*change*/

                    /*change*/
                    vm.fecha = $window.sessionStorage.dateString;
                    vm.hora = $window.sessionStorage.hourString;
                    vm.fechahora = getDateFromStringForView(vm.fecha, "normal") + " " + vm.hora;                    

                    vm.date = new Date($window.sessionStorage.date);
                    /**/

                    vm.alpha = $window.sessionStorage.alpha; /*change*/
                    vm.type = $window.sessionStorage.type; /*change*/
                    vm.typeHours = $window.sessionStorage.typeHours; /*change*/
                    vm.typeDate = $window.sessionStorage.typeDate; /*change*/
                } else {

                    vm.fechahora = "Selección multiple";
                    vm.hideMultiple = false;
                    $('#divMultiple').show();
                     
                    vm.fechasSeleccionadas = "";
                    for (var ap in vm.apptsInfo) {
                        var rg = vm.apptsInfo[ap].key.split("|");
                        vm.fechasSeleccionadas += getDateFromStringForView(rg[6], "normal") + " " + rg[7] + " - ";

                        vm.MultipleDatesTotal.push(getDateFromStringForView(rg[6], "normal") + " " + rg[7]);

                    }

                    if (vm.fechasSeleccionadas.length > 0)
                        vm.fechasSeleccionadas = vm.fechasSeleccionadas.substring(0, vm.fechasSeleccionadas.length - 2);

                }
                vm.isMultiple = !vm.hideMultiple;

                if (vm.isMultiple) {
                    $('#divequipmentsperappt').css("visibility", "visible");
                }

                //recupera el nombre del patio de la lista del servicio
                for (var k in vm.yardsList) {
                    if (vm.yardsList[k].YardId == vm.varyard) {
                        vm.varyardname = vm.yardsList[k].Name;
                    }
                }

                //en el create busca cuando le das click al boton
                //recupera el nombre de la accion de lista del servicio
                for (var k in vm.actiontypeList) {
                    if (vm.actiontypeList[k].Code == vm.varactiontype) {
                        vm.varactiontypename = vm.actiontypeList[k].Name;
                    }
                }

                //si es pickup muestra todos por defecto ocultando el check hasta que se añada el flag de gateout para 
                //poder visualizar los deshabilitados para el gateout
                if (vm.varactiontype == 'P') {
                    vm.muestraCheck = false;
                } else {
                    vm.muestraCheck = true;
                }
                
                //cuando editas carga la data por defecto
                if (vm.appointmentId > 0) {
                    getAppointmentById(vm.appointmentId);
                } else {
                    //permite validar los businesspartners en el save                    
                    disableDriverPlate();

                    vm.cargainicial = false;
                    vm.validacionesIniciales = 2;
                }

                // Cuando User es Rol Trucker cargar el Trucker asociado
                blockTruckerControls();
                setDefaultTrucker();

            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        }

        function getTruckerAsociate() {
            var associateTrucker = common.localStorageService.get('GetBusinessPartnerUserRolesQuery');
            return {
                TruckerId: associateTrucker.BusinessPartnerId,
                Name: associateTrucker.Name,
                DocumentNumber: associateTrucker.DocumentNumber
            };
        }

        function blockTruckerControls() {
            if (vm.isEdit && userRolIsTrucker()) {
                $('#trucker_value').attr('disabled', 'disabled');
                $('#rutTrucker_value').attr('disabled', 'disabled');
            }
        }

        function setDefaultTrucker() {
            if (userRolIsTrucker() && !vm.isEdit) {
                var trucker = getTruckerAsociate();                
                $scope.selectedTrucker = {
                    BusinessPartnerId: trucker.TruckerId, Name: trucker.Name
                };
                $scope.selectedTruckerRut = {
                    BusinessPartnerId: trucker.TruckerId, DocumentNo: trucker.DocumentNumber
                };
            }
        }

        function getShipperId() {
            if (userRolIsShipper()) {
                var shipper = getTruckerAsociate();
                if (shipper)
                    return shipper.TruckerId;
            }
            return null;
        }

        function showAddPlateNoModal(event) {
            if (vm.selectedTruckerId)
                $timeout(function () { $("#appointmentCreatePlateNo").modal("show"); }, 100);
            else
                toastr.info($translate.instant('views.appointment.SelectShipperForAssociatedDriver'));
        }

        function showAddDriverModal(event) {
            ShowOrHideLink();

            if (vm.selectedTruckerId)
                $timeout(function () { $("#appointmentCreateDriver").modal("show"); }, 100);
            else
                toastr.info($translate.instant('views.appointment.SelectShipperForAssociatedDriver'));
        }

        function getAppointmentById(appointmentId) {
            vm.isEdit = true;
            vm.actiontypeId = vm.varactiontype;
            vm.tituloPrincipal = $translate.instant('views.appointment.titleAppointmentEdit');

            datacontext.appointment.getAppointmentById(appointmentId).then(function (data) {                                
                datappointment = data.Appointment;
                
                if (datappointment) {
                    vm.appointmentNo = datappointment.AppointmentNo;
                    vm.referenceno = datappointment.ReferenceDocumentNo;
                    vm.depotOrderId = datappointment.DepotOrderId;
                    vm.depotOrderNo = datappointment.DepotOrderNo;
                    vm.referenceDocumentNo = datappointment.ReferenceDocumentNo;
                    vm.vesselId = datappointment.VesselId;
                    vm.voyageId = datappointment.VoyageId;
                    vm.placa = datappointment.LicensePlateNo;
                    vm.vardocumenttype = datappointment.DocumentTypeId;
                    vm.selectedAssignedToId = datappointment.ScheduledTo;
                    vm.isEditDisabled = datappointment.AppointmentRedirectDetail

                    if (datappointment.AppointmentRedirectDetail) {
                        toastr.error($translate.instant('views.appointment.UpdatedByAnotherUser'));
                    }

                    $('#placa_value').val(datappointment.LicensePlateNo);
                    $('#customer_ref').val(datappointment.CustomerName);
                    $('#carrier_ref').val(datappointment.CarrierName);

                    $scope.selectedDepotOrder = {
                        DepotOrderId: datappointment.DepotOrderId, DepotOrderNo: datappointment.DepotOrderNo, ReferenceDocumentNo: datappointment.ReferenceDocumentNo, VesselId: datappointment.VesselId, VoyageId: datappointment.VoyageId, CarrierId: datappointment.CarrierId, CustomerId: datappointment.CustomerId, CarrierName: datappointment.CarrierName, CustomerName: datappointment.CustomerName
                    };
                    $scope.selectedTrucker = {
                        BusinessPartnerId: datappointment.TruckerId, Name: datappointment.TruckerName
                    };
                    $scope.selectedDriver = {
                        BusinessPartnerId: datappointment.DriverId, Name: datappointment.DriverName
                    };
                    $scope.selectedAssignedTo = {
                        BusinessPartnerId: datappointment.ScheduledTo, Name: datappointment.ScheduledToName
                    };
                    $scope.selectedTruckerRut = {
                        BusinessPartnerId: datappointment.TruckerId, DocumentNo: datappointment.TruckerRUTNo
                    };
                    $scope.selectedRut = {
                        BusinessPartnerId: datappointment.DriverId, DocumentNo: datappointment.RUTNo
                    };
                }

                vm.getEquipments();
                loadAppConfig(datappointment.AppointmentEquipments);

                createNewDatasource(true);

            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        }

        //Boton buscar create appointment
        function getEquipments(customerId) {
            if ($('#idc').val() == "")
                $('#idc').val(customerId);

            var idyard = 0
            if (vm.varyard != "")
                idyard = parseInt(vm.varyard);

            vm.actiontypeId = vm.varactiontype;

            //solo busca cuando sea crear appointment
            //ahora debe buscar en todos los casos
            if (vm.referenceno.length == 0 && vm.depotOrderId == null) {
                toastr.warning($translate.instant('views.appointment.nroReferenceOrDepotOrder'));
                return false;
            }

            var model = {
                DepotOrderId: vm.depotOrderId, IsChangeDepot: vm.IsChangeDepot, ReferenceDocumentNo: vm.referenceno, ActionType: vm.actiontypeId, VesselId: vm.vesselId, VoyageId: vm.voyageId, YardId: idyard, DefaultLanguageId: 1
            };
            
            return datacontext.appointment.getEquipmentsByCriteria(model).then(function (data) {
                var doeId = -1;
                $(data.Equipments).each(function (e, v) {
                    if (v.DepotOrderEquipmentId === null)
                        v.DepotOrderEquipmentId = doeId;
                    doeId--;
                });

                vm.gridOptions.rowData = [];
                vm.gridOptions.api.onNewRows();                

                datappointments = {};
                
                if (data.Equipments) {
                    var equipments = data.Equipments;
                    datappointments = equipments.filter(function (e1, index) {
                        if (equipments[index].AppointmentEquipmentId > 0)
                            return true;
                            
                        var rows = $(vm.gridOptions2.rowData).filter(function (e2, requestedEquipment) {
                            return (requestedEquipment.DepotOrderId == equipments[index].DepotOrderId && requestedEquipment.DepotOrderEquipmentId == equipments[index].DepotOrderEquipmentId);
                        });

                        return rows.length == 0;
                    });
                }

                createNewDatasource(false);
                $('#nroRecords').html('<strong>' + $translate.instant('views.appointment.from') + " " + vm.gridOptions.rowData.length + " " + $translate.instant('views.appointment.results'));
            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        }

        function limpiaBusquedaEquipos(originField) {
            if (!vm.isEdit) {
                if (originField == null || originField == '') {
                    $('#referenceno_value').val('');
                    $('#depot_order_value').val('');
                }

                if (originField == 'dep') {
                    $('#referenceno_value').val('');
                    originField = '';
                }

                if (originField == 'ref') {
                    $('#depot_order_value').val('');
                    originField = '';
                }

                $('#customer_ref').val('');
                $('#carrier_ref').val('');

                //para el borrado de la depot order despues de haber ingresado alguna en el textbox
                //mantiene los datos de vessel y voyage en caso de haber seleccion
                //solo los elimina si cambias documentos, revisar si es necesario mantener asi
                if (originField == null || originField == '') {
                    vm.selectedDepotOrder = null;
                    vm.selectedReferenceNo = null;
                    vm.depotOrderId = "";
                    vm.referenceno = "";
                    vm.vesselId = "";
                    vm.voyageId = "";
                }

                vm.getEquipments(0);
            }        
        }

        function limpiaOnNewDepotOrReferenceNo() {
            if (!vm.isEdit) {
                $('#customer_ref').val('');
                $('#carrier_ref').val('');
                $('#referenceno_value').val('');
                vm.referenceno = null;
                vm.referenceDocumentNo = null;
                vm.getEquipments(0);
            }
        }

        function getEquipmentSizeTypeIdsRestriction() {
            datacontext.appointment.getEquipmentSizeTypeIdsRestriction().then(function (data) {
                vm.equipmentsizeAllow1 = data.EquipmentSizeType.AllowsOnly1;
                vm.equipmentsizeAllow2 = data.EquipmentSizeType.AllowsOnly2;
            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        }

        function getDocumentTypes() {
            var c = $window.sessionStorage.codeActionType;

            datacontext.appointment.getDocumentTypes("M", c).then(function (data) {
                vm.documenttypeList = data.DocumentTypes;

                //en el edit ya tiene datos
                if (!vm.vardocumenttype)
                    vm.vardocumenttype = data.DocumentTypes[0].DocumentTypeId;                

            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        }

        function getTruckerDriverPlateConfiguration(driverOrPlate) {

            var c = $window.sessionStorage.codeActionType;
            var onlyTruckerDriver = true;
            var onlyTruckerPlate = false;

            if (driverOrPlate == "P") {
                onlyTruckerDriver = false;
                onlyTruckerPlate = true;
            }

            datacontext.appointment.getTruckerDriverPlateConfiguration(onlyTruckerDriver, onlyTruckerPlate, c).then(function (data) {

                if (driverOrPlate == "D")
                    vm.truckerDriverAllowed = data;
                else //P
                    vm.truckerPlateAllowed = data;

            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });

        }

        function getDriverDocuments() {

            return datacontext.appointment.getDriverRoleTypeDocuments();
        }
        function getTruckDocuments() {

            return datacontext.appointment.getTruckDocumentTypes();
        }

        function getDepotOrderSearchSetting() {

            var c = $window.sessionStorage.codeActionType;
            var sPar = "AllowAppointmentCreationPickup";

            if (!c)
                c = "D";

            if (c == "D")
                sPar = "AllowAppointmentCreationDropOff";

            datacontext.appointment.getDepotOrderSearchSetting(sPar).then(function (data) {
                $(data).each(function(a, b) {
                    vm.operationtypemovement = vm.operationtypemovement + b.Name + ",";
                });

            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        }

        function newEquipment(selectedRow) {
            var equipment = {
                "DepotOrderEquipmentId": selectedRow.DepotOrderEquipmentId,
                "DepotOrderSummaryId": selectedRow.DepotOrderSummaryId,
                "QuantityToSchedule": selectedRow.QuantityToSchedule,
                "DepotOrderId": selectedRow.DepotOrderId,
                "CarrierId": selectedRow.CarrierId,
                "ClassId": selectedRow.ClassId,
                "EquipmentSizeTypeId": selectedRow.EquipmentSizeTypeId,
                "DepotOrderId": selectedRow.DepotOrderId,
                "YardScheduleHourId": selectedRow.YardScheduleHourId
            };

            return equipment;
        }

        function newGroupedEquipment(selectedRow) {
            var PeriodPerAppt = 1;
            if (selectedRow.PeriodPerAppt) {
                PeriodPerAppt = parseInt(selectedRow.PeriodPerAppt);
            }

            var equipment =
                {
                    "PeriodPerAppt": PeriodPerAppt,
                    "ScheduledEquipments": selectedRow.ScheduledEquipments,
                    "SizeTypeId": selectedRow.SizeTypeId,
                    "SizeTypeName": selectedRow.SizeTypeName,
                    "SizeTypeQnt": selectedRow.SizeTypeQnt,
                    "UsedEquipments": selectedRow.UsedEquipments,
                    "TotalEquipments": selectedRow.TotalEquipments,
                    "CarrierId": selectedRow.CarrierId,
                    "ClassId": selectedRow.ClassId,
                    "EquipmentSizeTypeId": selectedRow.EquipmentSizeTypeId,
                    "DepotOrderId": selectedRow.DepotOrderId,
                    "YardScheduleHourId": selectedRow.YardScheduleHourId
                };
            return equipment;
        }

        function newUnGroupedEquipment(selectedRow) {
            if (vm.isMultiple == true) {
                var equipment =
                    {
                        "DepotOrderEquipmentId": selectedRow.DepotOrderEquipmentId,
                        "DepotOrderSummaryId": selectedRow.DepotOrderSummaryId,
                        "SizeTypeId": selectedRow.EquipmentSizeTypeId,
                        "SizeTypeName": selectedRow.SizeTypeName,
                        "SizeValue": selectedRow.SizeValue,
                        "QuantityToSchedule": selectedRow.QuantityToSchedule,
                        "CarrierId": selectedRow.CarrierId,
                        "ClassId": selectedRow.ClassId,
                        "EquipmentSizeTypeId": selectedRow.EquipmentSizeTypeId,
                        "MultipleTruckerId": selectedRow.MultipleTruckerId,
                        "MultipleDriverId": selectedRow.MultipleDriverId,
                        "MultiplePlate": selectedRow.MultiplePlate,
                        "DepotOrderId": selectedRow.DepotOrderId,
                        "PeriodPerAppt": selectedRow.PeriodPerAppt,
                        "YardScheduleHourId": selectedRow.YardScheduleHourId
                    };

                return equipment;
            }
            else {
                var equipment =
                    {
                        "DepotOrderEquipmentId": selectedRow.DepotOrderEquipmentId,
                        "DepotOrderSummaryId": selectedRow.DepotOrderSummaryId,
                        "SizeTypeId": selectedRow.EquipmentSizeTypeId,
                        "SizeTypeName": selectedRow.SizeTypeName,
                        "SizeValue": selectedRow.SizeValue,
                        "QuantityToSchedule": selectedRow.QuantityToSchedule,
                        "CarrierId": selectedRow.CarrierId,
                        "ClassId": selectedRow.ClassId,
                        "EquipmentSizeTypeId": selectedRow.EquipmentSizeTypeId,
                        "DepotOrderId": selectedRow.DepotOrderId,
                        "YardScheduleHourId": selectedRow.YardScheduleHourId
                    };

                return equipment;
            }
        }

        function resetPageData(message) {
            $timeout(function () {
                let messageSuccess = $translate.instant('views.appointment.saveSuccessful');

                if (message !== "" && message !== null)
                    messageSuccess += message;

                toastr.info(messageSuccess);
                
                vm.apptsInfo = [];
                $window.sessionStorage.selectedApptsInfo = [];
                $('.ngdialog-close').click();
                $rootScope.startDatepicker();
                $rootScope.checksForAppCreation = [];
            });
        }

        function singleAppointment() {
            //ui-ref    
            $window.sessionStorage.type = angular.copy(vm.varactiontype);
            vm.actiontypeId = angular.copy(vm.varactiontype);

            //la placa puede ser texto normal o lo que se selecciono del autocomplete
            vm.placa = $('#placa_value').val();
            if (vm.placa.length < 1)
                vm.placa = null;

            if (!(vm.varyard && vm.varoperationtype && vm.actiontypeId)) {
                toastr.info($translate.instant('views.appointment.fieldsYardOperationAction'));
                return false;
            }

            if (!vm.selectedTruckerId) {
                toastr.info($translate.instant('views.appointment.fieldTrucker'));
                return false;
            }

            if (!vm.selectedDriverId) {
                if (vm.truckerDriverRequired == true) {
                    toastr.info($translate.instant('views.appointment.youCanOnlySelectADriverThatIsRelatedWithTheTrucker'));
                }
                else {
                    toastr.info($translate.instant('views.appointment.enterDriverIfYouNeedToAddANewDriverClickAddButton'));
                }

                return false;
            }

            if (!vm.placa) {
                toastr.info($translate.instant('views.appointment.insertPlate'));
                return false;
            }

            if (!vm.vardocumenttype) {
                toastr.info($translate.instant('views.appointment.EnterDocumentType'));
                return false;
            }

            var nroFilasSeleccionadas = 0;

            for (var v in vm.gridOptions2.rowData) {
                nroFilasSeleccionadas++;
            }

            if (nroFilasSeleccionadas == 0) {
                toastr.info($translate.instant('views.appointment.selectEquipmentForAppointment'));
                return false;
            }

            if (nroFilasSeleccionadas > 2) {
                toastr.info($translate.instant('views.appointment.selectEquipment'));
                return false;
            }

            //validar tipos de contenedor seleccionados
            //tipos de contenedor seleccionados            
            var selectedEquipmentSizeIds = [];
            for (var v in vm.gridOptions2.rowData) {
                selectedEquipmentSizeIds.push(vm.gridOptions2.rowData[v].EquipmentSizeTypeId);
            }

            //si hay tipos de contenedores seleccionados validalos
            if (selectedEquipmentSizeIds) {

                var nroContenedores = selectedEquipmentSizeIds.length;
                var solopermite1 = false;
                var solopermite2 = false;
                var tipovalido = true;
                var incluidovalido = true;

                //si hay uno de 40 (esta en allow1) y se ha seleccionado mas de un contenedor 
                for (var eq in selectedEquipmentSizeIds) {

                    var idsz = selectedEquipmentSizeIds[eq];
                    solopermite1 = $.inArray(idsz, vm.equipmentsizeAllow1);
                    solopermite2 = $.inArray(idsz, vm.equipmentsizeAllow2);
                    if (solopermite1 >= 0 && nroContenedores > 1) {
                        tipovalido = false;
                    }

                    //esta bloqueado (ni 1 o 2 de ese tipo)
                    if (solopermite1 < 0 && solopermite2 < 0) {
                        incluidovalido = false;
                    }
                }
            }

            //solo valida para el save
            if (!tipovalido) {
                toastr.info($translate.instant('views.appointment.youCannotSelectMultiplesEquipmentsOfThisType'));
                return false;
            }

            if (!incluidovalido) {
                toastr.info($translate.instant('views.appointment.oneOfTheSelectedEquipmentsHasAnInvalidType'));
                return false;
            }

            if (validarFechasAppointment(vm.alpha, vm.type, vm.typeHours, vm.typeDate, vm.appointmentTemplateId)) {

                var selectedEquipments = [];
                for (var v in vm.gridOptions2.rowData) {
                    selectedEquipments.push(newEquipment(vm.gridOptions2.rowData[v]));
                }


                var appointment;
                if (!vm.isEdit)
                    appointment = {
                        "AppointmentId": vm.appointmentId,
                        "TimeZone": new Date().getTimezoneOffset(),
                        "AppointmentTemplateId": vm.appointmentTemplateId,
                        "GroupId": 49, "YardId": vm.varyard,
                        "AppointmentDate": vm.date,
                        "AppointmentType": 0,
                        "OperationType": vm.varoperationtype,
                        "ActionType": vm.actiontypeId,
                        "DocumentTypeId": vm.vardocumenttype,
                        "CustomerId": vm.customerId,
                        "CarrierId": vm.carrierId,
                        "ScheduledTo": vm.selectedAssignedToId,
                        "DepotOrderId": vm.depotOrderId,
                        "DriverId": vm.selectedDriverId,
                        "TruckerId": vm.selectedTruckerId,
                        "LicensePlateNo": vm.placa,
                        "ReferenceDocumentNo": vm.referenceDocumentNo,
                        "VoyageId": vm.voyageId,
                        "VesselId": vm.vesselId,
                        "LanguageId": "1",
                        "AppointmentEquipments": selectedEquipments
                    };
                else {

                    /*Graba uno nuevo con los mismos datos y cancela el anterior independientmente si fuese edit o create*/
                    //antes                      
                    appointment = angular.copy(datappointment);
                    appointment.AppointmentId = angular.copy(vm.appointmentId);
                    appointment.TruckerId = angular.copy(vm.selectedTruckerId);
                    appointment.DriverId = angular.copy(vm.selectedDriverId);
                    appointment.LicensePlateNo = angular.copy(vm.placa);
                    appointment.AppointmentTemplateId = angular.copy(vm.appointmentTemplateId);
                    appointment.CustomerId = angular.copy(vm.customerId);
                    appointment.CarrierId = angular.copy(vm.carrierId);
                    appointment.DepotOrderId = angular.copy(vm.depotOrderId);                    
                    appointment.DocumentTypeId = angular.copy(vm.vardocumenttype);
                    appointment.ScheduledTo = angular.copy(vm.selectedAssignedToId);
                    appointment.TimeZone = new Date().getTimezoneOffset();
                    appointment.AppointmentEquipments = angular.copy(vm.gridOptions2.rowData);

                }
                appointment.TimeLimitHours = vm.typeHours;
                appointment.LocalAppointmentDate = $rootScope.createAppointment.localAppointmentDate;

                var valido = true;

                if (!selectedEquipments.length > 0) {
                    toastr.warning($translate.instant('views.appointment.selectEquipmentForAppointment'));
                    return false;
                }
                if (vm.isEdit) {
                    if (!(vm.appointmentTemplateId && vm.varyard && vm.date && vm.varoperationtype &&
                        vm.actiontypeId && vm.selectedDriverId && vm.selectedTruckerId &&
                        vm.placa)) {
                        valido = false;
                    }
                } else {
                    if (!(vm.varyard && vm.date && vm.varoperationtype &&
                        vm.actiontypeId && vm.selectedDriverId && vm.selectedTruckerId &&
                        vm.placa)) {
                        valido = false;
                    }
                }
                
                if (valido) {
                    RemoveInvalidDepotOrderEquipmentId(appointment.AppointmentEquipments);
                    var appt = JSON.stringify(appointment);

                    vm.ClickButtonSave = true;
                    $('#btnDes').addClass('DisableCursor');

                    if (!vm.isEdit) {
                        datacontext.appointment.saveAppointment(appt).then(function (data) {
                            if (data.Result == 1) {
                                resetPageData(data.Message);
                            } else {
                                if (data.Result == 8) {
                                    toastr.warning(data.Message);
                                } else {
                                    if (data.Message && data.Message.indexOf("autoriz") >= 0) {
                                        toastr.error(data.Message);
                                    } else {
                                        toastr.error($translate.instant('views.appointment.saveError') + data.Message);
                                        $('.ngdialog-close').click();
                                    }
                                }
                            }
                            EnableSaveButton();
                            vm.actionRefresh = false;
                        },
                            function (err) {
                                EnableSaveButton();
                                vm.actionRefresh = false;
                                if (err.status)
                                    toastr.error(err.info);
                            });
                    } else {
                        datacontext.appointment.editAppointment(appt).then(function (data) {
                            if (data.Result == 1) {
                                resetPageData(data.Message);
                            } else {
                                if (data.Result == 8) {
                                    toastr.warning(data.Message);
                                } else {
                                    if (data.Message && data.Message.indexOf("autoriz") >= 0)
                                        toastr.error(data.Message);
                                    else {
                                        toastr.error($translate.instant('views.appointment.saveError') + data.Message);
                                        $('.ngdialog-close').click();
                                    }
                                }
                            }
                            EnableSaveButton();
                        },
                            function (err) {
                                EnableSaveButton();
                                if (err.status)
                                    toastr.error(err.info);
                            });
                    }
                }
                else {
                    EnableSaveButton();
                    toastr.info($translate.instant('views.appointment.inOrderToUpdateYouMustCompleteTheInformation'));
                    return false;
                }
            } else {
                EnableSaveButton();
                toastr.info($translate.instant('views.appointment.operationCannotBeCompletedForAppointmentInTheSelectedDate'));
            }
        }

        function EnableSaveButton() {
            vm.ClickButtonSave = false;
            $('#btnDes').removeClass('DisableCursor');
        }

        function multipleCreation2() {
            // validaciones
            $window.sessionStorage.type = vm.varactiontype;
            vm.actiontypeId = vm.varactiontype;
            var equipmentsPerAppointment = parseInt($('#ddlequipmentsperappt').val());

            var nroFilasSeleccionadas = 0;
            for (var v in vm.gridOptions2.rowData) {
                nroFilasSeleccionadas++;
            }
            for (var v in vm.gridOptions3.rowData) {
                nroFilasSeleccionadas++;
            }
            if (nroFilasSeleccionadas == 0) {
                toastr.info($translate.instant('views.appointment.selectEquipmentForAppointment'));
                return false;
            }
            if (!(vm.varyard && vm.varoperationtype && vm.actiontypeId)) {
                toastr.info($translate.instant('views.appointment.inOrderToUpdateYouMustCompleteTheInformation'));
                return false;
            }

            var selectedGroupedEquipments = [];
            var selectedUngroupedEquipments = [];
            //TODO acceder a los datos de la grilla normal si tuviese datos para la seleccion multiple
            //TODO solo se pueden agregar equipos sin numeros asignados en el gatein
            if (vm.gridOptions2.rowData) {
                for (var v in vm.gridOptions2.rowData) {
                    selectedUngroupedEquipments.push(newUnGroupedEquipment(vm.gridOptions2.rowData[v]));
                }
            }

            selectedUngroupedEquipments = selectedUngroupedEquipments;
            var eqps40NotValid = 0;
            for (var eqp in selectedUngroupedEquipments) {
                if (selectedUngroupedEquipments[eqp].SizeValue == "40" && equipmentsPerAppointment == 2)
                    eqps40NotValid++;                
            }

            if (eqps40NotValid > 1) {
                toastr.info($translate.instant('views.appointment.CantSelect2EquipmentsOf40ToGenerateAppointment'));
                return false;
            }

            //acceder a los datos de la grilla agrupada si tuviese datos para la seleccion multiple
            if (vm.gridOptions3.rowData) {
                for (var v in vm.gridOptions3.rowData) {
                    selectedGroupedEquipments.push(newGroupedEquipment(vm.gridOptions3.rowData[v]));
                }
            }

            //recuperar el total de equipos para armar las citas 
            var totalEquipments = [];
            if (selectedGroupedEquipments && selectedGroupedEquipments.length > 0) {
                totalEquipments = selectedGroupedEquipments[0].TotalEquipments;
            }

            //para cada tipo agrupado ir armando y acumulando las citas segun los equipos totales (cada grupo es una cita)
            var appointment;
            var appointments = [];
            var appointmentsToSend = [];

            var equipmentsGroupContainer = [];
            var apptTotal = 0;
            var apptTotalPerSize = 0;
            var eqPerAppt = 0;
            var eqToSchedule = 0;

            ///////////////////////////////////////////////////////////////////
            //validar tipos de contenedor seleccionados
            //tipos de contenedor seleccionados            
            var selectedEquipmentSizeIds = [];

            //si no es agrupado sacalos directo de la grilla a donde se pasan
            //si es agrupodo saca los equipos de la columna que los guarda en la agrupacion
            //for (var v in vm.gridOptions2.rowData) {
            //    selectedEquipmentSizeIds.push(vm.gridOptions2.rowData[v].EquipmentSizeTypeId);
            //}

            //agrupados
            for (var v in totalEquipments) {
                if (totalEquipments[v].EquipmentSizeTypeId != null) {
                    selectedEquipmentSizeIds.push(totalEquipments[v].EquipmentSizeTypeId);
                }
            }

            //o no agrupados
            for (var v in selectedUngroupedEquipments) {
                selectedEquipmentSizeIds.push(selectedUngroupedEquipments[v].SizeTypeId);
            }

            //si hay tipos de contenedores seleccionados validalos
            if (selectedEquipmentSizeIds) {

                var nroContenedores = selectedEquipmentSizeIds.length;
                var solopermite1 = false;
                var solopermite2 = false;
                var tipovalido = true;
                var incluidovalido = true;

                //si hay uno de 40 (esta en allow1) y se ha seleccionado mas de un contenedor 
                for (var eq in selectedEquipmentSizeIds) {
                    var idsz = selectedEquipmentSizeIds[eq];

                    if (idsz != null) {
                        solopermite1 = $.inArray(idsz, vm.equipmentsizeAllow1);
                        solopermite2 = $.inArray(idsz, vm.equipmentsizeAllow2);
                    }

                    //esta bloqueado (ni 1 o 2 de ese tipo)
                    if (solopermite1 < 0 && solopermite2 < 0)
                        incluidovalido = false;
                }
            }

            if (!incluidovalido) {
                toastr.info($translate.instant('views.appointment.oneOfTheSelectedEquipmentsHasAnInvalidType'));
                return false;
            }

            for (var geq in selectedGroupedEquipments) {

                apptTotalPerSize = selectedGroupedEquipments[geq].ScheduledEquipments / selectedGroupedEquipments[geq].PeriodPerAppt;
                apptTotal += apptTotalPerSize;
                eqPerAppt = selectedGroupedEquipments[geq].PeriodPerAppt;
                eqToSchedule = selectedGroupedEquipments[geq].ScheduledEquipments;

                //tomar los equipos que tengan el mismo size type id del registro que contiene el mismo de tipo de equipos acumulado                    
                var equipmentTotalPerSize = [];
                //asegurandonos de que solo se acumulen el numero deseado de equipos a agendar por tipo
                var equipmentsToTake = 1;
                for (var eq in totalEquipments) {
                    if ((totalEquipments[eq].EquipmentSizeTypeId == selectedGroupedEquipments[geq].SizeTypeId) && (equipmentsToTake <= eqToSchedule)) {
                        equipmentTotalPerSize.push(newEquipment(totalEquipments[eq]));
                        equipmentsToTake++;
                    }
                }

                //crear
                var equipmentsGroup = [];
                for (var i = 0; i < equipmentTotalPerSize.length; i++) {
                    equipmentsGroup.push(equipmentTotalPerSize[i]);
                    //si es exacto, guarda el grupo y resetea el acumulador para pasar hasta el siguiente exacto
                    if (((i + 1) % eqPerAppt) == 0) {
                        equipmentsGroupContainer.push(equipmentsGroup);
                        equipmentsGroup = [];
                    }
                    //obteniendo los equipos sobrantes en caso de que el total no sea multiplo exacto
                    //para considerar los equipos del residuo del total (ultimo equipo)
                    if (((i + 1) == equipmentTotalPerSize.length) && ((i + 1) % eqPerAppt) > 0) {
                        equipmentsGroupContainer.push(equipmentsGroup);
                        equipmentsGroup = [];
                    }
                }

            }

            /////////////////////////nueva logica

            //Logica
            var selectedUngroupedEquipments = [];
            if (vm.gridOptions2.rowData) {
                for (var v in vm.gridOptions2.rowData) {
                    selectedUngroupedEquipments.push(newUnGroupedEquipment(vm.gridOptions2.rowData[v]));
                }
            }
            var listIndexAlreadyUsed = [];
            var finalAppListToSave = [];
            var negativeIds = -1;

            $(selectedUngroupedEquipments).each(function (index, item) {
                var indiceHora = $.inArray(item.PeriodPerAppt, vm.MultipleDatesTotal);

                if (equipmentsPerAppointment == 1) {
                    var newHeaderApp = getAppointmentHeaders(vm.apptsInfo[indiceHora]);
                    newHeaderApp.AppointmentId = negativeIds--;
                    item.AppointmentEquipmentId = negativeIds--;
                    item.AppointmentId = newHeaderApp.AppointmentId;
                    newHeaderApp.AppointmentEquipments = [];
                    newHeaderApp.AppointmentEquipments.push(item);
                    finalAppListToSave.push(newHeaderApp);
                }
                else if (equipmentsPerAppointment == 2) {
                    var AppToSum = $(finalAppListToSave).filter(function (finalIdx, FinalItem) {
                        return FinalItem.AppointmentEquipments.length == 1 && FinalItem.AppointmentEquipments[0].PeriodPerAppt == item.PeriodPerAppt && FinalItem.AppointmentEquipments[0].MultiplePlate == item.MultiplePlate && FinalItem.AppointmentEquipments[0].MultipleTruckerId == item.MultipleTruckerId && FinalItem.AppointmentEquipments[0].MultipleDriverId == item.MultipleDriverId;

                    })[0];

                    if (AppToSum != null) {
                        item.AppointmentId = AppToSum.AppointmentId;
                        item.AppointmentEquipmentId = negativeIds--;
                        AppToSum.AppointmentEquipments.push(item);
                    }
                    else {
                        var newHeaderApp = getAppointmentHeaders(vm.apptsInfo[indiceHora]);
                        newHeaderApp.AppointmentId = negativeIds--;
                        item.AppointmentEquipmentId = negativeIds--;
                        item.AppointmentId = newHeaderApp.AppointmentId;
                        newHeaderApp.AppointmentEquipments = [];
                        newHeaderApp.AppointmentEquipments.push(item);
                        finalAppListToSave.push(newHeaderApp);
                    }
                }
                listIndexAlreadyUsed.push(index);

            });

            //guardar[]
            var toEvlauateDriver = [];
            var toEvlauatePlate = [];
            $(finalAppListToSave).each(function (a, b) {

                var firstTrucker = b.AppointmentEquipments[0].MultipleTruckerId;
                var firstDriver = b.AppointmentEquipments[0].MultipleDriverId;
                var firstPlate = b.AppointmentEquipments[0].MultiplePlate;

                b.LicensePlateNo = firstPlate;
                b.DriverId = firstDriver;
                b.TruckerId = firstTrucker;
                toEvlauatePlate.push("" + b.LicensePlateNo + "," + b.AppointmentDate);
                toEvlauateDriver.push("" + b.DriverId + "," + b.AppointmentDate);
            });

            var CanSave = true;
            $(finalAppListToSave).each(function (a, b) {

                var PlatesFiltered = $(toEvlauatePlate).filter(function (c, d) {
                    return d == "" + b.LicensePlateNo + "," + b.AppointmentDate;
                });
                if (PlatesFiltered.length >= 2) {
                    CanSave = false;
                    return false;
                }
                var DriverFiltered = $(toEvlauateDriver).filter(function (c, d) {
                    return d == "" + b.DriverId + "," + b.AppointmentDate;
                });
                if (DriverFiltered.length >= 2) {
                    CanSave = false;
                    return false;
                }
            });

            if (CanSave == true) {
                RemoveInvalidDepotOrderEquipmentIdInAppointmentList(finalAppListToSave);

                var appointmentJSON = JSON.stringify(finalAppListToSave);
                vm.ClickButtonSave = true;
                $('#btnDes').addClass('DisableCursor');
                datacontext.appointment.saveAppointmentMultiple(appointmentJSON).then(function (data) {
                    if (data.Result == 1) {
                        resetPageData(data.Message);
                    } else {
                        if (data.Message && data.Message.indexOf("autoriz") >= 0) {
                            toastr.error(data.Message);
                        } else {
                            toastr.error($translate.instant('views.appointment.saveError') + data.Message);
                            $('.ngdialog-close').click();                            
                        }
                        
                        EnableSaveButton();
                    }
                },
                    function (err) {
                        if (err.status)
                            toastr.error(err.info);
                    });
            }
            else {
                toastr.info($translate.instant('views.appointment.CantScheduleMoreThanOneApptWithSameDriverAndOrPlateBetweenSameSchedule'));
                return false;
            }
            return false;
        }

        function getAppointmentHeaders(hr) {
            var newHeaderApp;
            var alpha; var typeP; var typeHours; var datep;
            var typeDate; var appointmentId; var appointmentTemplateId;
            var reg = hr;
            var regParts = reg.key.split("|");

            alpha = new Date(regParts[0]);
            datep = alpha;
            typeP = JSON.parse(regParts[1]);
            typeHours = parseInt(regParts[2]);
            typeDate = new Date(regParts[3]);
            appointmentId = parseInt(regParts[4]);
            appointmentTemplateId = parseInt(regParts[5]);
            if (!datep) {
                return false;
            }
            if (validarFechasAppointment(alpha, typeP, typeHours, typeDate, appointmentTemplateId)) {
                newHeaderApp = {
                    "AppointmentId": appointmentId, "TimeZone": new Date().getTimezoneOffset(), "AppointmentTemplateId": appointmentTemplateId, "GroupId": 49, "YardId": vm.varyard, "AppointmentDate": datep, "AppointmentType": 0, "OperationType": vm.varoperationtype, "ActionType": vm.actiontypeId, "DocumentTypeId": vm.vardocumenttype, "CustomerId": vm.customerId, "CarrierId": vm.carrierId, "ScheduledTo": vm.selectedAssignedToId, "DepotOrderId": vm.depotOrderId, "DriverId": vm.selectedDriverId, "TruckerId": vm.selectedTruckerId, "LicensePlateNo": vm.placa, "ReferenceDocumentNo": vm.referenceDocumentNo, "VoyageId": vm.voyageId, "VesselId": vm.vesselId, "LanguageId": "1", "AppointmentEquipments": null
                };
            }
            return newHeaderApp;
        }

        function multipleAppointment() {
            $window.sessionStorage.type = vm.varactiontype;
            vm.actiontypeId = vm.varactiontype;
            var equipmentsPerAppointment = parseInt($('#ddlequipmentsperappt').val());

            //la placa puede venir del autocomplete o libre
            vm.placa = $('#placa_value').val();
            if (vm.placa.length < 1)
                vm.placa = null;

            if (!(vm.varyard && vm.varoperationtype && vm.actiontypeId)) {
                toastr.info($translate.instant('views.appointment.fieldYardOperationAction'));
                return false;
            }

            if (!vm.vardocumenttype) {
                toastr.info($translate.instant('views.appointment.EnterDocumentType'));
                return false;
            }

            var nroFilasSeleccionadas = 0;
            for (var v in vm.gridOptions2.rowData) {
                nroFilasSeleccionadas++;
            }
            for (var v in vm.gridOptions3.rowData) {
                nroFilasSeleccionadas++;
            }

            //si no hay equipos en ninguna grilla mixta o agrupada indicarlo
            if (nroFilasSeleccionadas == 0) {
                toastr.info($translate.instant('views.appointment.selectEquipmentForAppointment'));
                return false;
            }

            if (!(vm.varyard && vm.varoperationtype && vm.actiontypeId)) {
                toastr.info('Complete los datos para la actualización');
                return false;
            }

            var selectedGroupedEquipments = [];
            var selectedUngroupedEquipments = [];
            //TODO acceder a los datos de la grilla normal si tuviese datos para la seleccion multiple
            //TODO solo se pueden agregar equipos sin numeros asignados en el gatein
            if (vm.gridOptions2.rowData) {
                for (var v in vm.gridOptions2.rowData) {
                    selectedUngroupedEquipments.push(newUnGroupedEquipment(vm.gridOptions2.rowData[v]));
                }
            }

            selectedUngroupedEquipments = selectedUngroupedEquipments;
            var eqps40NotValid = 0;
            for (var eqp in selectedUngroupedEquipments) {
                if (selectedUngroupedEquipments[eqp].SizeValue == "40" && equipmentsPerAppointment == 2) {
                    eqps40NotValid++;
                }
            }

            if (eqps40NotValid > 1) {
                toastr.info("No se pueden seleccionar 2 Equipos de 40' para generar una Cita");
                return false;
            }

            //acceder a los datos de la grilla agrupada si tuviese datos para la seleccion multiple
            if (vm.gridOptions3.rowData) {
                for (var v in vm.gridOptions3.rowData) {
                    selectedGroupedEquipments.push(newGroupedEquipment(vm.gridOptions3.rowData[v]));
                }
            }

            //recuperar el total de equipos para armar las citas 
            var totalEquipments = [];
            if (selectedGroupedEquipments && selectedGroupedEquipments.length > 0) {
                totalEquipments = selectedGroupedEquipments[0].TotalEquipments;
            }

            //para cada tipo agrupado ir armando y acumulando las citas segun los equipos totales (cada grupo es una cita)
            var appointment;
            var appointments = [];
            var appointmentsToSend = [];

            var equipmentsGroupContainer = [];
            var apptTotal = 0;
            var apptTotalPerSize = 0;
            var eqPerAppt = 0;
            var eqToSchedule = 0;

            ///////////////////////////////////////////////////////////////////
            //validar tipos de contenedor seleccionados
            //tipos de contenedor seleccionados            
            var selectedEquipmentSizeIds = [];

            //si no es agrupado sacalos directo de la grilla a donde se pasan
            //si es agrupodo saca los equipos de la columna que los guarda en la agrupacion
            //for (var v in vm.gridOptions2.rowData) {
            //    selectedEquipmentSizeIds.push(vm.gridOptions2.rowData[v].EquipmentSizeTypeId);
            //}

            //agrupados
            for (var v in totalEquipments) {
                if (totalEquipments[v].EquipmentSizeTypeId != null) {
                    selectedEquipmentSizeIds.push(totalEquipments[v].EquipmentSizeTypeId);
                }
            }

            //o no agrupados
            for (var v in selectedUngroupedEquipments) {
                selectedEquipmentSizeIds.push(selectedUngroupedEquipments[v].SizeTypeId);
            }

            //si hay tipos de contenedores seleccionados validalos
            if (selectedEquipmentSizeIds) {

                var nroContenedores = selectedEquipmentSizeIds.length;
                var solopermite1 = false;
                var solopermite2 = false;
                var tipovalido = true;
                var incluidovalido = true;

                //si hay uno de 40 (esta en allow1) y se ha seleccionado mas de un contenedor 
                for (var eq in selectedEquipmentSizeIds) {

                    var idsz = selectedEquipmentSizeIds[eq];

                    if (idsz != null) {
                        solopermite1 = $.inArray(idsz, vm.equipmentsizeAllow1);
                        solopermite2 = $.inArray(idsz, vm.equipmentsizeAllow2);
                    }

                    //esta bloqueado (ni 1 o 2 de ese tipo)
                    if (solopermite1 < 0 && solopermite2 < 0) {
                        incluidovalido = false;
                    }
                }
            }
            
            if (!incluidovalido) {
                toastr.info($translate.instant('views.appointment.oneOfTheSelectedEquipmentsHasAnInvalidType'));
                return false;
            }

            for (var geq in selectedGroupedEquipments) {

                apptTotalPerSize = selectedGroupedEquipments[geq].ScheduledEquipments / selectedGroupedEquipments[geq].PeriodPerAppt;
                apptTotal += apptTotalPerSize;
                eqPerAppt = selectedGroupedEquipments[geq].PeriodPerAppt;
                eqToSchedule = selectedGroupedEquipments[geq].ScheduledEquipments;

                //tomar los equipos que tengan el mismo size type id del registro que contiene el mismo de tipo de equipos acumulado                    
                var equipmentTotalPerSize = [];
                //asegurandonos de que solo se acumulen el numero deseado de equipos a agendar por tipo
                var equipmentsToTake = 1;
                for (var eq in totalEquipments) {
                    if (
                        (totalEquipments[eq].EquipmentSizeTypeId == selectedGroupedEquipments[geq].SizeTypeId)
                        &&
                        (equipmentsToTake <= eqToSchedule)
                    ) {
                        equipmentTotalPerSize.push(newEquipment(totalEquipments[eq]));
                        equipmentsToTake++;
                    }
                }

                //crear

                var equipmentsGroup = [];
                for (var i = 0; i < equipmentTotalPerSize.length; i++) {
                    equipmentsGroup.push(equipmentTotalPerSize[i]);
                    //si es exacto, guarda el grupo y resetea el acumulador para pasar hasta el siguiente exacto
                    if (((i + 1) % eqPerAppt) == 0) {
                        equipmentsGroupContainer.push(equipmentsGroup);
                        equipmentsGroup = [];
                    }
                    //obteniendo los equipos sobrantes en caso de que el total no sea multiplo exacto
                    //para considerar los equipos del residuo del total (ultimo equipo)
                    if (((i + 1) == equipmentTotalPerSize.length) && ((i + 1) % eqPerAppt) > 0) {
                        equipmentsGroupContainer.push(equipmentsGroup);
                        equipmentsGroup = [];
                    }
                }

            }

            //mixto, si paso equipos a la grilla de abajo en el caso multiple             
            if (selectedUngroupedEquipments && selectedUngroupedEquipments.length > 0) {

                var mixtoProcess = true;
                var equipmentsPerAppointment = parseInt($('#ddlequipmentsperappt').val());
                var sizeList = ["20", "40"];
                var equipmentsGroup = [];

                for (var x = 0; x < sizeList.length; x++) {

                    var mixtoProcess = true;
                    var selectedUngroupedEquipmentsCheck = selectedUngroupedEquipments.slice(0);

                    while (mixtoProcess) {

                        var idxToRemove = 0;
                        //para ambos sizes and types
                        //sacar un equipo, meterlo en un grupo, agruparlo y luego repetir el proceso hasta que ya no hayan equipos  
                        for (var i = 0; i < selectedUngroupedEquipmentsCheck.length; i++) {

                            //los de 20 solo seran grupos si encajan con el numero de equipos por cita (1 ó 2)
                            if (selectedUngroupedEquipmentsCheck[i].SizeValue == sizeList[x] && sizeList[x] == "20") {
                                equipmentsGroup.push(selectedUngroupedEquipmentsCheck[i]);
                                if ((equipmentsGroup.length % equipmentsPerAppointment) == 0) {
                                    equipmentsGroupContainer.push(equipmentsGroup);
                                    equipmentsGroup = [];
                                }
                                //si sobrase uno de 20 considerarlo para colocarlo como cita automaticamente
                                if (selectedUngroupedEquipmentsCheck.length == 1 && equipmentsPerAppointment == 2) {
                                    equipmentsGroupContainer.push(equipmentsGroup);
                                    equipmentsGroup = [];
                                }
                            }
                            //los de 40 siempre harán grupos independientemente del número de equipos por cita
                            if (selectedUngroupedEquipmentsCheck[i].SizeValue == sizeList[x] && sizeList[x] == "40") {
                                equipmentsGroup.push(selectedUngroupedEquipmentsCheck[i]);
                                equipmentsGroupContainer.push(equipmentsGroup);
                                equipmentsGroup = [];
                            }
                            idxToRemove = i;
                            break;
                        }

                        selectedUngroupedEquipmentsCheck.splice(idxToRemove, 1);
                        if (selectedUngroupedEquipmentsCheck.length == 0) {
                            mixtoProcess = false;
                        }
                    }
                }

            }

            //armando las citas totales segun la selección del calendario sin los equipos 
            //igual
            if (vm.apptsInfo && vm.apptsInfo.length > 0) {

                for (var hr in vm.apptsInfo) {

                    var alpha; var typeP; var typeHours; var datep;
                    var typeDate; var appointmentId; var appointmentTemplateId;

                    var reg = vm.apptsInfo[hr];
                    var regParts = reg.key.split("|");

                    //vm.date = alpha 
                    alpha = new Date(regParts[0]);
                    datep = alpha;
                    typeP = JSON.parse(regParts[1]);
                    typeHours = parseInt(regParts[2]);
                    typeDate = new Date(regParts[3]);
                    appointmentId = parseInt(regParts[4]);
                    appointmentTemplateId = parseInt(regParts[5]);

                    //validacion de la fecha y el appointment template id
                    if (!datep) {
                        toastr.info('Fecha seleccionada incorrecta. Por favor vuelva al Calendario y seleccione correctamente');
                        return false;
                    }

                    //en el metodo simple alpha pasa como newDate(), y en la funcion se le vuelve a aplicar newDate(), aplicar lo mismo                            
                    if (validarFechasAppointment(alpha, typeP, typeHours, typeDate, appointmentTemplateId)) {
                        appointment = {
                            "AppointmentId": appointmentId, "TimeZone": new Date().getTimezoneOffset(), "AppointmentTemplateId": appointmentTemplateId, "GroupId": 49, "YardId": vm.varyard, "AppointmentDate": datep, "AppointmentType": 0, "OperationType": vm.varoperationtype, "ActionType": vm.actiontypeId, "DocumentTypeId": vm.vardocumenttype, "CustomerId": vm.customerId, "CarrierId": vm.carrierId, "ScheduledTo": vm.selectedAssignedToId, "DepotOrderId": vm.depotOrderId, "DriverId": vm.selectedDriverId, "TruckerId": vm.selectedTruckerId, "LicensePlateNo": vm.placa, "ReferenceDocumentNo": vm.referenceDocumentNo, "VoyageId": vm.voyageId, "VesselId": vm.vesselId, "LanguageId": "1", "AppointmentEquipments": null
                        };
                        appointments.push(appointment);
                    }

                }
            }

            //el numero de citas equivaldra al numero de grupos armados
            //indicar al usuario cuando las citas que se pueden crear difieren con el numero de citas seleccionadas                
            //igual
            if (equipmentsGroupContainer && equipmentsGroupContainer.length > 0) {

                for (var i = equipmentsGroupContainer.length; i--;) {
                    if (equipmentsGroupContainer[i].length == 0) {
                        equipmentsGroupContainer.splice(i, 1);
                    }
                }

                if (equipmentsGroupContainer.length == appointments.length) {
                    for (var apt in appointments) {
                        appointments[apt].AppointmentEquipments = equipmentsGroupContainer[apt];
                    }
                }
                if (appointments.length > equipmentsGroupContainer.length) {

                    for (var eqg in equipmentsGroupContainer) {
                        appointments[eqg].AppointmentEquipments = equipmentsGroupContainer[eqg];
                    }
                    //} else
                    //    return false;
                }
                if (appointments.length < equipmentsGroupContainer.length) {
                    toastr.info("La cantidad de Equipos seleccionados es mayor a la cantidad de horarios seleccionadas. Por favor modificar");
                    return false;
                }

                //solo considerar las citas con equipos asociados
                if (appointments && appointments.length > 0) {
                    for (var apt in appointments) {
                        if (appointments[apt].AppointmentEquipments && appointments[apt].AppointmentEquipments.length > 0) {
                            appointmentsToSend.push(appointments[apt]);
                        }
                    }
                    //decrementar el appointmentid a -1 por cada appointment creado
                    var nroAppt = -1;
                    for (var apt in appointmentsToSend) {
                        if (appointmentsToSend[apt].AppointmentEquipments && appointments[apt].AppointmentEquipments.length > 0) {
                            appointmentsToSend[apt].AppointmentId = nroAppt--;
                        }
                    }
                }

                $(appointmentsToSend).each(function (a, b) {
                    var firstTrucker = b.AppointmentEquipments[0].MultipleTruckerId;
                    var firstDriver = b.AppointmentEquipments[0].MultipleDriverId;
                    var firstPlate = b.AppointmentEquipments[0].MultiplePlate;

                    b.LicensePlateNo = firstPlate;
                    b.DriverId = firstDriver;
                    b.TruckerId = firstTrucker;
                });

                //guardar el appointment masivo                 
                var appointmentJSON = JSON.stringify(appointmentsToSend);
            }

            return false;
        }

        function saveAppointment() {
            if (vm.ClickButtonSave !== false) return;
            
            if (vm.isMultiple)
                multipleCreation2();
            else
                singleAppointment();
        }

        function getDateFromString(fechaString) {
            if (fechaString && fechaString.length > 2) {
                var fpartes = fechaString.split("/");
                if (fpartes.length && fpartes.length > 0) {
                    return fpartes[2] + "-" + fpartes[1] + "-" + fpartes[0];
                }
            }
            return "";
        }

        function getDateFromStringForView(fechaString) {
            if (fechaString && fechaString.length > 2) {
                var fpartes = fechaString.split("/");
                if (fpartes.length && fpartes.length > 0) {
                    return fpartes[1] + "/" + fpartes[0] + "/" + fpartes[2];
                }
            }
            return "";
        }

        function newDocument(row) {
            var doc = {
                "Code": "DRI", "BusinessPartnerDocumentTypeDetailId": 0, "Status": 0, "DocumentTypeID": row.DocumentTypeId, "DocumentType": row.DocumentType, "DocumentNumber": row.DocumentNumber, "DocumentName": row.DocumentName + "-" + row.DocumentType, "StartDateString": row.StartDateString, "ExpirationDateString": row.ExpirationDateString, "StartDate": getDateFromString(row.StartDateString), "ExpirationDate": getDateFromString(row.ExpirationDateString), "IsChecked": false, "IsActive": true, "RowStatus": true
            };
            return doc;
        }

        function newRole(row) {
            var role = {
                "BusinessPartnerRoleId": 0, "BusinessPartnerId": 0, "RoleTypeId": row.RoleTypeId, "IsActive": true, "RowStatus": true
            };
            return role;
        }

        function clearDocuments() {
            vm.bpnombre = "";
            vm.bpcorreo = "";
            vm.bptelefono = "";

            var rowData = vm.gridOptions1.rowData;
            for (var i = 0; i < rowData.length; i++) {
                rowData[i].DocumentNumber = "";
                rowData[i].ExpirationDate = "";
                rowData[i].ExpirationDateString = "";
                rowData[i].StartDate = "";
                rowData[i].StartDateString = "";
            }

            vm.gridOptions1.rowData = rowData;
            vm.gridOptions1.api.onNewRows();
        }

        function closeNewDriverDlg() {
            // Borrar contenido de los input, y cerrar el modal
            $('#txtNombre').val('');
            $('#txtCorreo').val('');
            $('#txtTelefono').val('');
            $('#appointmentCreateDriver').modal('hide');
        }

        function saveDocuments() {
            var valido = false;
            if (!vm.selectedTruckerId) {
                toastr.info("Seleccionar el transportista asociado al conductor en la ventana anterior.");
                return false;
            }

            if ($('#txtNombre').val().trim().length <= 0) {
                toastr.info("El campo Nombre es obligatorio.");
                return false;
            }

            var emailRgx = /[^\@]+\@[^\@]+/;
            if (!emailRgx.test(vm.bpcorreo)) {
                toastr.info("Formato de correo inválido.");
                return false;
            }

            var rowData = vm.gridOptions1.rowData;
            for (var i = 0; i < rowData.length; i++) {
                if (rowData[i].MandatoryT == "Si" && (rowData[i].DocumentNumber == "" || rowData[i].DocumentNumber.length < 4)) {
                    toastr.info("Se debe llenar el Tipo de Documento:" + rowData[i].DocumentName);
                    return false;
                    break;
                }

                if (rowData[i].MandatoryExpirationDateT == "Si" && (rowData[i].ExpirationDateString == "" || rowData[i].ExpirationDateString.length < 4)) {
                    toastr.info("Se debe llenar la Fecha de Expiración.");
                    return false;
                    break;
                }
            }

            valido = true;
            var documentsToSave = [];
            var rolesToSave = [];
            if (valido) {

                for (var i = 0; i < rowData.length; i++) {
                    var item = rowData[i];
                    if (item.DocumentNumber != "") {
                        documentsToSave.push(newDocument(item));
                    }
                }

                for (var i = 0; i < 1; i++) {
                    var item = rowData[i];
                    rolesToSave.push(newRole(item));
                }

                //"RoleTypeId": 1, 
                var partnerToSave = {
                    "Code": "DRI", "RoleType": "DRIVER", "BPAssociationId": vm.selectedTruckerId, "Name": vm.bpnombre, "Email": vm.bpcorreo, "Phone": vm.bptelefono, "IsActive": true, "RowStatus": true
                };
                partnerToSave.BusinessPartnerDocumentTypeDetails = documentsToSave;
                partnerToSave.BusinessPartnerRoles = rolesToSave;

                //para obtener el numero de rut que se presenta despues de grabar el conductor
                var rutNo = "";
                for (var d in documentsToSave) {
                    if (documentsToSave[d].DocumentType == "RUT") {
                        rutNo = documentsToSave[d].DocumentNumber;
                    }
                }
                datacontext.appointment.saveDriver(partnerToSave).then(function (data) {
                    if (data.Result == 1) {
                        $scope.selectedDriver = {
                            BusinessPartnerId: data.CreatedBusinessPartner.BusinessPartnerId, Name: data.CreatedBusinessPartner.Name,
                            DocumentNo: rutNo
                        };
                        $scope.selectedRut = {
                            BusinessPartnerId: data.CreatedBusinessPartner.BusinessPartnerId, DocumentNo: rutNo
                        };
                        vm.selectedDriverFnDefinition({ originalObject: $scope.selectedDriver });
                        toastr.info($translate.instant('views.appointment.saveSuccessful'));
                        $("#appointmentCreateDriver").modal("hide");
                        clearDocuments();
                    } else {
                        toastr.error($translate.instant('views.appointment.saveError') + " " + data.Message);
                    }
                },
                    function (err) {
                        if (err.status)
                            toastr.error(err.info);
                    });


            } else {
                toastr.info("Complete los datos adecuadamente");
            }

        }

        function clearTruckDocuments() {
            vm.bpPlateNo = "";
            vm.selectedTruckerName = "";
            
            var rowData = vm.grdTruckDocumentTypes.rowData;
            for (var i = 0; i < rowData.length; i++) {
                rowData[i].DocumentNumber = "";
                rowData[i].ExpirationDate = "";
                rowData[i].ExpirationDateString = "";
                rowData[i].StartDate = "";
                rowData[i].StartDateString = "";
            }

            vm.grdTruckDocumentTypes.rowData = rowData;
            if (vm.grdTruckDocumentTypes.api)
                vm.grdTruckDocumentTypes.api.onNewRows();

        }

        function saveTruckDocumentTypes() {
            var valido = false;
            if (!vm.selectedTruckerId) {
                toastr.info("Seleccionar el transportista asociado al conductor en la ventana anterior.");
                return false;
            }
            if ($('#txtPlateNo').val().length <= 0) {
                toastr.info("El campo Placa es obligatorio.");
                return false;
            }
            var rowData = vm.grdTruckDocumentTypes.rowData;
            for (var i = 0; i < rowData.length; i++) {
                if (rowData[i].TruckDocumentType && rowData[i].TruckDocumentType.Mandatory && 
                    (rowData[i].DocumentNumber == "" || rowData[i].DocumentNumber == null || rowData[i].DocumentNumber.length < 4)) {
                    toastr.info("Se debe llenar el Tipo de Documento:" + rowData[i].DocumentName);
                    return false;
                    break;
                }

                if (rowData[i].TruckDocumentType && rowData[i].TruckDocumentType.MandatoryExpirationDate && (rowData[i].ExpirationDateString == "" || rowData[i].ExpirationDateString.length < 4) && (rowData[i].ExpirationDateString == "" || rowData[i].ExpirationDateString.length < 4)) {
                    toastr.info("Se debe llenar la Fecha de Expiración.");
                    return false;
                    break;
                }
            }
            
            valido = true;
            var documentsToSave = [];
            var rolesToSave = [];
            if (valido) {

                for (var i = 0; i < rowData.length; i++) {
                    var item = rowData[i];
                    if (item.StartDateString != "") {
                        item.StartDateString = getDateFromStringForView(item.StartDateString);
                    }

                    if (item.ExpirationDateString != "") {
                        item.ExpirationDateString = getDateFromStringForView(item.ExpirationDateString);
                    }
                }

                //"RoleTypeId": 1, 
                var truckToSave = {
                    "TruckId": -1, "BusinessPartnerId": vm.selectedTruckerId, "Plate": vm.bpPlateNo, "IsActive": true, "RowStatus": true
                };
                truckToSave.TruckDocumentTypeTrucks = rowData;
                
                //para obtener el numero de rut que se presenta despues de grabar el conductor
                var rutNo = "";
                for (var d in documentsToSave) {
                    if (documentsToSave[d].DocumentType == "RUT") {
                        rutNo = documentsToSave[d].DocumentNumber;
                    }
                }

                datacontext.appointment.createTruck(truckToSave).then(function (data) {
                    if (data.Result == 1) {
                        vm.fromSelected = true;
                        vm.selectedTruckerPlate = data.Truck.Plate;
                        $('#placa_value').val(data.Truck.Plate);

                        toastr.info($translate.instant('views.appointment.saveSuccessful'));
                        $("#appointmentCreatePlateNo").modal("hide");
                        clearTruckDocuments();
                    } else {
                        toastr.info($translate.instant('views.appointment.saveError') + " " + data.Message);
                    };
                },
                    function (err) {
                        if (err.status)
                            toastr.error(err.info);
                    });
            } else {
                toastr.info("Complete los datos adecuadamente");
            }
        }

        function viewCellRendering() {
            return '<i class="fa fa-eye"></i>';
        }

        function cellClickedfunct(cell) {
            var equipments = [];
            for (var v in vm.gridOptions.selectedRows) {
                equipments.push(vm.gridOptions.selectedRows[v]);
            }
            if (equipments.length > 0 && typeof vm.selectedDriver.originalObject !== "undefined" && typeof vm.selectedTrucker.originalObject !== "undefined") {
                var model = {
                    AppointmentId: -1, ActiveEquipments: equipments, TruckerId: vm.selectedTrucker.originalObject["businessPartnerId"], DriverId: vm.selectedDriver.originalObject["businessPartnerId"]
                };
            }

        }

        function numberNewValueHandler(params) {
            var newQty = parseInt(params.newValue);
            if (newQty > params.data.SizeTypeQnt || isNaN(newQty)) {
                toastr.info("Solo puede ingresar un valor igual o menor a la cantidad actual de equipos para ese tipo");
            }
            else {
                params.data.ScheduledEquipments = newQty;
            }

        }

        function goAppointments() {
            $window.sessionStorage.type = vm.varactiontype;
            $state.go('root.appointmentMainApptSchedule', {
                reload: true
            });
        }

        function goMain() {
            $state.go('root.appointment', {
                reload: true
            });
        }

        //resetear la depot order
        function clearDepotOrder(item) {
            $('#depot_order_value').val('');
            $('#depot_order_value').val('');
            vm.depotOrderId = "";
            vm.depotOrderNo = "";
        }

        function disableDriverPlate() {
            $('#trucker_value').attr('disabled', 'disabled');
            $('#rutTrucker_value').attr('disabled', 'disabled');
            $('#driver_value').attr('disabled', 'disabled');
            $('#rut_value').attr('disabled', 'disabled');
            $('#placa_value').attr('disabled', 'disabled');
        }

        function clearDriverPlate(field, action) {
            //deshabilitar
            if (action == 'D') {
                if (field == 'DP') {
                    vm.selectedDriverId == null;
                    $('#driver_value').val('');
                    vm.selectedDriver = null;
                    $('#rut_value').val('');
                    vm.selectedTruckerPlate = null;
                    $('#placa_value').val('');                    
                    $('#driver_value').attr('disabled', 'disabled');
                    $('#rut_value').attr('disabled', 'disabled');
                    $('#placa_value').attr('disabled', 'disabled');

                }
            }

            //habilitar
            if (action == 'E') {
                if (field == 'DP') {
                    $('#driver_value').removeAttr('disabled');
                    $('#rut_value').removeAttr('disabled');
                    $('#placa_value').removeAttr('disabled');
                }
            }

        }

        $scope.getBusinessPartnerByName = function (name) {

            return datacontext.appointment.getBusinessPartnerByName(name);
        };

        $scope.getTruckersByName = function (name) {
            return datacontext.appointment.getTruckersByName(name);
        };

        $scope.getDriversByName = function (name) {
            var truckerPartnerId = -1;
            if (vm.truckerDriverRequired) {
                truckerPartnerId = vm.selectedTruckerId;
            }
            if (!vm.truckerDriverRequired) {
                truckerPartnerId = 0;
            }

            ShowOrHideLink();

            var mdriver = {
                BPAssociationId: truckerPartnerId, Code: "", Name: name, DocumentNo: "", DocumentCode: "", Role: "DRI",
                Paging: { Page: 1, Take: 20 }
            };
            return datacontext.appointment.getDriversByCriteria(mdriver);
        };

        $scope.getTruckersByName = function (name) {
            var mtrucker = {
                Code: "", Name: name, DocumentNo: "", DocumentCode: "", Role: "TRU", CurrentRoleCode: vm.roleSelected
            };
            return datacontext.appointment.getDriversByCriteria(mtrucker);
        };

        $scope.getRutTruckerByNo = function (docNro) {
            var mtrucker = {
                Code: "", Name: "", DocumentNo: docNro, DocumentCode: "RUT", Role: "TRU", CurrentRoleCode: vm.roleSelected
            };
            return datacontext.appointment.getDriversByCriteria(mtrucker);
        };

        $scope.getRutByNo = function (docNro) {
            var mrut = {
                Code: "", Name: "", DocumentNo: docNro, DocumentCode: "RUT", Role: "DRI"
            };
            return datacontext.appointment.getDriversByCriteria(mrut);
        };

        $scope.getTruckerPlates = function (name) {
            var truckerPartnerId = 0;
            if (vm.truckerPlateRequired) {
                truckerPartnerId = vm.selectedTruckerId;
            }

            return datacontext.appointment.getTruckerPlates(name, truckerPartnerId);
        };

        $scope.getDepotOrderByName = function (name) {
            var request = {
                criteria: name, actionType: vm.varactiontype,
                yardId: vm.varyard, operationTypeMovementCode: vm.operationtypemovement, shipperId: getShipperId(),
                yardScheduleHourId: $window.sessionStorage.yardScheduleHourId, appointmentDate: $window.sessionStorage.dateString
            };

            return datacontext.appointment.getDepotOrdersByNo(request);
        };

        $scope.selectedTruckerFn = function (selected) {
            vm.validacionesIniciales++;
            if (selected) {
                var businessPartnerId = selected.originalObject['BusinessPartnerId'];
                vm.selectedTruckerRut = selected.originalObject['DocumentNo'];
                vm.selectedTruckerName = selected.originalObject['Name'];
                vm.selectedTruckerId = businessPartnerId;
                vm.selectedTruckerObj = selected;
                $('#rutTrucker_value').val(vm.selectedTruckerRut);

                if (vm.validacionesIniciales > 2) {
                    validateBusinessPartner("T", businessPartnerId);
                }

                if (vm.isEditDisabled === false) {
                    $('#driver_value').removeAttr('disabled');
                    $('#rut_value').removeAttr('disabled');
                    $('#driver_value').val('');
                    vm.selectedDriverId = null;
                }
            } else {

                vm.selectedTruckerId = null;
                vm.selectedDriverId = null;
                vm.selectedRut = null;
                vm.selectedTruckerName = null;
                if (vm.truckerPlateRequired || vm.truckerDriverRequired) {
                    $('#placa_value').attr('disabled', 'disabled');
                    $('#placa_value').val('');
                    vm.selectedTruckerPlate = null;

                    $('#rut_value').attr('disabled', 'disabled');
                    $('#rut_value').val('');
                    
                    $('#driver_value').attr('disabled', 'disabled');
                    $('#driver_value').val('');
                    $('#rutTrucker_value').val('');
                    ShowOrHideLink();
                }

            }
        };

        //si inicia con initial-value en el load
        $scope.selectedDriverFn = selectedDriverFnDefinition;

        function selectedDriverFnDefinition(selected) {
            vm.validacionesIniciales++;

            if (selected) {
                var businessPartnerId;
                vm.selectedDriverId = selected.originalObject['BusinessPartnerId'];
                businessPartnerId = vm.selectedDriverId;

                vm.selectedRut = selected.originalObject['DocumentNo'];
                $('#rut_value').val(vm.selectedRut);
                if (vm.isEditDisabled === false)
                    $('#placa_value').removeAttr('disabled');

                if (selected.originalObject.Name != $('#driver_value').val()) {
                    $('#driver_value').val(selected.originalObject.Name);
                }

                if (vm.validacionesIniciales > 2) {
                    validateBusinessPartner("D", businessPartnerId);
                }
            } else {
                vm.selectedDriverId = null;
                vm.selectedRut = null;
                $('#rut_value').val('');

                if (vm.truckerPlateRequired) {
                    vm.selectedTruckerPlate = null;
                    $('#placa_value').val('');
                }
            }
        };

        $scope.selectedAssignedToFn = function (selected) {
            if (selected) 
                vm.selectedAssignedToId = selected.originalObject['BusinessPartnerId'];
             else 
                vm.selectedAssignedToId = null;
        };

        $scope.selectedRutFn = function (selected) {
            vm.validacionesIniciales++;

            if (selected) {
                vm.selectedDriverId = selected.originalObject['BusinessPartnerId'];
                vm.selectedRut = selected.originalObject['DocumentNo'];                
                $('#driver_value').val(selected.originalObject['Name']);
                if (vm.isEditDisabled === false)
                    $('#placa_value').removeAttr('disabled');

                if (vm.validacionesIniciales > 2)
                    validateBusinessPartner("D", selected.originalObject['BusinessPartnerId']);

            } else {
                vm.selectedRut = null;
                vm.selectedDriverId = null;
                $('#driver_value').val('');

                if (vm.truckerPlateRequired || vm.truckerDriverRequired) {
                    $('#placa_value').attr('disabled', 'disabled');
                    $('#placa_value').val('');
                    $('#rut_value').attr('disabled', 'disabled');
                    $('#rut_value').val('');
                    $('#driver_value').attr('disabled', 'disabled');
                    $('#driver_value').val('');
                    ShowOrHideLink();
                }
            }
        };

        $scope.selectedTruckerRutFn = function (selected) {
            if (selected) {
                vm.selectedTruckerId = selected.originalObject['BusinessPartnerId'];
                vm.selectedTruckerRut = selected.originalObject['DocumentNo'];
                $('#trucker_value').val(selected.originalObject['Name']);
                
                if (vm.isEditDisabled === false) {
                    $('#driver_value').removeAttr('disabled');
                    $('#rut_value').removeAttr('disabled');
                    $('#driver_value').val('');
                    $('#rut_value').val('');
                }
            } else {
                vm.selectedTruckerId = null;
                vm.selectedTruckerRut = null;
                $('#trucker_value').val('');

                $('#placa_value').attr('disabled', 'disabled');
                $('#placa_value').val('');
                $('#rut_value').attr('disabled', 'disabled');
                $('#rut_value').val('');
                $('#driver_value').attr('disabled', 'disabled');
                $('#driver_value').val('');

            }
        };

        $scope.focusOutAuto = focusOutAuto;

        function focusOutAuto() {
            if (vm.fromSelected == false) {
                if (vm.truckerPlateRequired && (vm.selectedTruckerPlate + "" == "[object Object]" || vm.selectedTruckerPlate == null)) {
                    changeSelected(null);
                }

            } else if (vm.fromSelected == true) {
                vm.fromSelected = false;
            }
        }

        $scope.selectedTruckerPlateFn = changeSelected;

        function changeSelected(selected) {
            if (selected) {
                vm.fromSelected = true;
                vm.selectedTruckerPlate = selected.originalObject['Plate'];
                $('#placa_value').val(selected.originalObject['Plate']);
            } else {

                if (vm.CleanText == true) {

                    vm.selectedTruckerPlate = null;
                    $('#placa_value').val('');
                    vm.CleanText = false;
                }
                else {
                    vm.selectedTruckerPlate = $('#placa_value').val();

                    if (vm.truckerPlateRequired) {
                        if (selected == null) {
                            if ($('#placa_dropdown').find('.angucomplete-row').length == 0) {
                                vm.CleanText = true;
                                $scope.$broadcast('angucomplete-alt:clearInput', 'placa');
                            }
                        }
                    }
                }
            }

        };

        $scope.inputChangedTruckerPlate = inputChangedTruckerPlate;

        function inputChangedTruckerPlate(a, b) {
        };

        //obteniendo nro de referencia de la depot order
        $scope.selectedDepotOrderFn = function (selected) {
            if (selected) {
                vm.selectedDepotOrder = selected;
                $scope.selectedDepotOrder = selected.originalObject;

                vm.referenceno = selected.originalObject['ReferenceDocumentNo'];
                vm.depotOrderId = selected.originalObject['DepotOrderId'];
                vm.depotOrderNo = selected.originalObject['DepotOrderNo'];
                vm.referenceDocumentNo = selected.originalObject['ReferenceDocumentNo'];
                vm.vesselId = selected.originalObject['VesselId'];
                vm.voyageId = selected.originalObject['VoyageId'];
                vm.IsChangeDepot = selected.originalObject['IsChangeDepot'];
                vm.customerId = selected.originalObject['CustomerId'];
                vm.carrierId = selected.originalObject['CarrierId'];
                vm.yardScheduleHourDetailPersonalizes = selected.originalObject['YardScheduleHourDetailPersonalizeIsAvailables'];

                if (selected.originalObject['DocumentTypeId']) {
                    vm.vardocumenttype = selected.originalObject['DocumentTypeId'];
                }

                $('#referenceno_value').val(selected.originalObject['ReferenceDocumentNo']);
                $('#customer_ref').val(selected.originalObject['CustomerName']);
                $('#carrier_ref').val(selected.originalObject['CarrierName']);

               if(!firstTimeOnEdit)
                validateSearchEquipments();

                firstTimeOnEdit = false;
            }
        }

        function validateSearchEquipments(){
            var isAvailable = vm.yardScheduleHourDetailPersonalizes.some(x => x.IsAvailable);
            if(isAvailable)
                vm.getEquipments();
            else
                vm.yardScheduleHourDetailPersonalizes.forEach(x => {
                    if(!x.IsAvailable)
                        toastr.warning($translate.instant(x.Message));
                });
        }

        function searchDepotOrder() {
            if (vm.referenceno && vm.varactiontype) {
                datacontext.appointment.getDepotOrderByRefDocNo(vm.referenceno, vm.vardocumenttype, vm.varactiontype, vm.varyard).then(function (data) {
                    if (data) {
                        if (data.DepotOrders.length > 0)
                            vm.selectedDepotOrder = data.DepotOrders[0];
                    }
                }, function (err) {
                    if (err.status)
                        toastr.error(err.info);
                });
            }
        }

        function getDepotOrderInfo(depotOrderId) {
            return datacontext.appointment.getDepotOrderSummaryCounters(depotOrderId).then(
                function (data) {
                    vm.depotorderinfo = [];
                    vm.depotorderinfo = data;
                    if (vm.depotorderinfo && vm.depotorderinfo.length > 0) {
                        $("#depotOrderInfo").modal("show");
                        if (vm.gridOptions4.api) {
                            vm.gridOptions4.rowData = vm.depotorderinfo;
                            vm.gridOptions4.api.onNewRows();
                        }
                    }
                },
                function (err) {
                    if (err.status)
                        toastr.error(err.info);
                }
            );
        }

        function validateBusinessPartner(roleType, businessPartnerId) {
            var businessPartnerNonbre = "Empresa de Transporte";
            if (roleType == "D")
                businessPartnerNonbre = "Conductor";
            
            if (businessPartnerId) {
                datacontext.appointment.getBusinessPartnerRestriction(businessPartnerId, roleType, "1").then(function (data) {
                    var result = data.Result;
                    var warning = data.Message;
                    if (result == 0) {
                        if (roleType == "D") {
                            $scope.$broadcast('angucomplete-alt:clearInput', 'driver');
                            toastr.info('No puede seleccionar este conductor. ' + warning);
                            vm.selectedDriverId == null;
                            vm.selectedDriver = {};
                            $('#rut_value').val('');
                        }
                        else {
                            $scope.$broadcast('angucomplete-alt:clearInput', 'trucker');
                            toastr.info('No puede seleccionar este transportista. ' + warning);
                            vm.selectedTruckerId == null;
                            vm.selectedTrucker = {};
                            $('#rutTrucker_value').val('');
                        }
                    } else if (result == 8) { //solo confirma cuando selecciona despues de cargar la pantalla
                        if (roleType == "D") {
                            $scope.$broadcast('angucomplete-alt:clearInput', 'driver');
                            $scope.$broadcast('angucomplete-alt:clearInput', 'rut');
                            vm.selectedDriverId == null;
                            vm.selectedDriver = {};
                            vm.selectedRut = {};
                            $('#rut_value').val('');
                            $('#driver_value').val('');
                            toastr.error(warning)
                        } else {
                            if (!confirm("¿Desea seleccionar este " + businessPartnerNonbre + "?. " + warning)) {
                                $scope.$broadcast('angucomplete-alt:clearInput', 'trucker');
                                vm.selectedTruckerId == null;
                                vm.selectedTrucker = {};
                                $('#rutTrucker_value').val('');
                            }
                        }
                    }
                }, function (err) {
                    err.info = err.info.replace(/\"/g, '');
                    if (err.status)
                        toastr.error(err.info);
                });
            } else {
                toastr.warning('Seleccionar ' + businessPartnerNonbre);
            }
        }

        function validatePlate() {
            datacontext.appointment.getPlateRestriction(vm.placa).then(function (data) {
                var result = data.Result;
                var warning = data.Message;

                if (result == 0) {
                    $('#placa').val('');
                    toastr.info('No puede seleccionar esta placa. ' + warning);
                }
                else if (result == 8 && !vm.cargainicial) {
                    if (!confirm("Esta placa tiene una observación. " + warning)) {
                        $('#placa').val('');
                        vm.placa = "";
                    }
                }

            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        }

        function validarFechasAppointment(Alpha, Type, TypeHours, TypeDate, AppointmentTemplateId) {
            var endDate = $rootScope.createAppointment.endDate;
            var now = new Date();
            var isValid;
            Type = Boolean(Type);
            TypeDate = new Date(TypeDate);
            TypeHours = parseInt(TypeHours);
            AppointmentTemplateId = parseInt(AppointmentTemplateId);
            Alpha = new Date(Alpha);

            if(now <= endDate)
                isValid = true;
            else if ((Alpha == now) || (Alpha > now)) {
                if (Type == true) {
                    now = now.setHours(now.getHours())
                    if (Alpha >= now)
                        isValid = true;
                    else
                        isValid = false;
                }
                else {
                    var ValidarHora = TypeDate.getHours();
                    if (ValidarHora > Alpha.getHours())
                        isValid = true;
                    else
                        isValid = false;
                }
            }
            else
                isValid = false;

            return isValid;
        }

        function loadAppConfig(dataloaded) {
            var foundTruckerDriver = false;
            var foundTruckerPlate = false;
            
            $(dataloaded).each(function (a, row) {
                if (row.OperationTypeMovementCode && row.OperationTypeMovementCode.length > 0) {
                    for (var i in vm.truckerDriverAllowed) {
                        if (vm.truckerDriverAllowed[i].Name == row.OperationTypeMovementCode) {
                            vm.truckerDriverRequired = true;
                            foundTruckerDriver = true;
                            break;
                        }
                    }
                    if (vm.truckerDriverRequired == true)
                        return false;
                }
            });

            ShowOrHideLink();
            $(dataloaded).each(function (a, row) {
                if (row.OperationTypeMovementCode && row.OperationTypeMovementCode.length > 0) {
                    for (var i in vm.truckerPlateAllowed) {
                        if (vm.truckerPlateAllowed[i].Name == row.OperationTypeMovementCode) {
                            vm.truckerPlateRequired = true;
                            foundTruckerPlate = true;
                            break;
                        }
                    }
                    if (vm.truckerPlateAllowed == true) 
                        return false;
                }
            });
            if (!foundTruckerDriver)
                vm.truckerDriverRequired = false;

            if (!foundTruckerPlate)
                vm.truckerPlateRequired = false;
        }

        ShowOrHideLink();
    }

    function ShowOrHideLink() {
    }

    function GetYardList() {
        var yardLst = [];
        angular.forEach(common.localStorageService.get('yardList'), function (value, key) {
            var yards = $(vm.yards).filter(function (a, b) { return b.Code == value.code });
            if (yards && yards.length > 0) {
                var yaradId = yards[0].YardId;
                var yardObj = {};
                yardObj.Code = value.code;
                yardObj.Name = value.name;
                yardObj.YardId = yaradId;
                yardLst.push(yardObj);
            }
        });
        return yardLst;
    }

    function RemoveInvalidDepotOrderEquipmentId(appointmentEquipments) {
        $(appointmentEquipments).each(function (e, v) {
            if (v.DepotOrderEquipmentId < 0)
                v.DepotOrderEquipmentId = null;
        });
    }

    function RemoveInvalidDepotOrderEquipmentIdInAppointmentList(appointmentList) {
        $(appointmentList).each(function (e1, appointment) {
            RemoveInvalidDepotOrderEquipmentId(appointment.AppointmentEquipments);
        });
    }
})();
